// ===============================
// JOIUSS LENS MAP — DEBUG HEADER
// ===============================
window.__JOIUSS_LENS_DEBUG__ = window.__JOIUSS_LENS_DEBUG__ || {};
window.__JOIUSS_LENS_DEBUG__.loadedAt = new Date().toISOString();
console.log("JOIUSS lens map loaded", window.__JOIUSS_LENS_DEBUG__.loadedAt);


(() => {
  // ============================================================
  // JOIUSS Lens Selector Controller (Dawn)
  // ============================================================

  if (window.__JOIUSS_LENS_MAP_BOUND__) return;
  window.__JOIUSS_LENS_MAP_BOUND__ = true;

    // ============================================================
  // INIT COUNT (debug): detect accidental double boot
  // ============================================================
  window.__JOIUSS_LENS_DEBUG__ = window.__JOIUSS_LENS_DEBUG__ || {};
  window.__JOIUSS_LENS_DEBUG__.initCount =
    (window.__JOIUSS_LENS_DEBUG__.initCount || 0) + 1;

  console.log("JOIUSS initCount:", window.__JOIUSS_LENS_DEBUG__.initCount);

  const JOIUSS_DEBUG = true;

  // If this ever hits 2+, something is booting twice (theme editor, app re-render, etc.)
  if (window.__JOIUSS_LENS_DEBUG__.initCount > 1) {
    console.warn("JOIUSS: init prevented (double init detected)");
    return;
  }

  // ============================================================
  // 1) DOM FINDERS
  // ============================================================
    const getProductInfo = () => document.querySelector("product-info");

    // Track which lens UI instance is active (important in Theme Editor / Preview)
// Track which lens UI instance is active (Theme Editor/Preview can render duplicates)
    let ACTIVE_ROOT = null;

    const uiRoot = () =>
    ACTIVE_ROOT || document.querySelector("[data-joiuss-lens]");

    // DEBUG (temporary): expose minimal helpers to console
window.__JOIUSS_LENS_DEBUG__ = window.__JOIUSS_LENS_DEBUG__ || {};
window.__JOIUSS_LENS_DEBUG__.getActiveRoot = () => ACTIVE_ROOT;
window.__JOIUSS_LENS_DEBUG__.getRoot = () => uiRoot();
window.__JOIUSS_LENS_DEBUG__.setActiveRoot = (el) => (ACTIVE_ROOT = el);

// Expose live state for quick console debugging
// (safe: contains only UI selections, no customer data)
window.__JOIUSS_LENS_DEBUG__.state = window.__JOIUSS_LENS_DEBUG__.state || null;



const modeWrap = () => uiRoot()?.querySelector("[data-joiuss-lens-mode]") || null;
const customPanel = () => uiRoot()?.querySelector("[data-custom-panel]") || null;
const frameNote = () => uiRoot()?.querySelector("[data-frame-note]") || null;
const helperEl = () => uiRoot()?.querySelector("[data-joiuss-helper]") || null;

// Scope steps within the active custom panel
const stepUse = () => customPanel()?.querySelector('[data-step="use"]') || null;
const stepType = () => customPanel()?.querySelector('[data-step="type"]') || null;
const stepColour = () => customPanel()?.querySelector('[data-step="colour"]') || null;
const swatchGrid = () => stepColour()?.querySelector("[data-joiuss-swatch-grid]") || null;
const stepReaderPower = () => customPanel()?.querySelector('[data-step="reader_power"]') || null;
const stepRx = () => customPanel()?.querySelector('[data-step="rx"]') || null;
const uploadRow = () => uiRoot()?.querySelector("[data-rx-upload-row]") || null;
const uploadWrap = () => uiRoot()?.querySelector("[data-rx-upload-wrap]") || null;
const uploadChooseBtn = () => uiRoot()?.querySelector("[data-rx-upload-choose]") || null;



const rxModal = (id) => document.querySelector(`[data-rx-modal="${CSS.escape(id)}"]`);


const readerRange = () =>
  stepReaderPower()?.querySelector('[data-reader-range]') || null;

const readerReadout = () =>
  stepReaderPower()?.querySelector('[data-reader-readout]') || null;



  // Bifocal shape UI (inside custom panel)
 const bifocalWrap = () =>
  customPanel()?.querySelector("[data-bifocal-shape-wrap]") || null;


  const getMapEl = () => {
    const pi = getProductInfo();
    if (!pi?.dataset?.productId) return null;

    return (
      document.getElementById(`joiuss-lens-map-${pi.dataset.productId}`) ||
      document.querySelector('[id^="joiuss-lens-map-"]')
    );
  };

  const readMap = () => {
    const el = getMapEl();
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      console.warn("JOIUSS lens map JSON parse failed", e);
      return null;
    }
  };

  const getAllProductForms = () => {
    const pi = getProductInfo();

    const formsInPI = pi
      ? Array.from(
          pi.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]')
        )
      : [];

    const globalForms = Array.from(
      document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]')
    );

    // Merge + de-dupe
    return Array.from(new Set([...formsInPI, ...globalForms]));
  };


  const getAddToCartButtons = () => {
    const buttons = [];
    getAllProductForms().forEach((form) => {
      form
        .querySelectorAll('button[name="add"], button[type="submit"]')
        .forEach((b) => buttons.push(b));
    });
    return buttons;
  };

  // ============================================================
  // RX UPLOAD helper: find the injected form input
  // ============================================================
  const getFormRxUploadInput = () => {
    const forms = getAllProductForms?.() || [];
    for (const form of forms) {
      const input = form.querySelector('[data-rx-upload-input]');
      if (input) return input;
    }
    return null;
  };

// ============================================================
// RX UPLOAD: ensure a real <input type="file"> exists INSIDE the product form
// - Shopify will only create a clickable link in the order admin if the FILE
//   is submitted as a line item property from within the add-to-cart form.
// ============================================================
const ensureRxUploadInput = () => {
  // If we already have a file input inside a product form, we're done.
  const existing = getFormRxUploadInput();
  if (existing) {
    // Ensure correct property name (file property must be unique and not clash with text props)
    if (!existing.name || existing.name !== "properties[_Prescription Upload]") {
      existing.name = "properties[_Prescription Upload]";
    }
    return existing;
  }

  const forms = getAllProductForms?.() || [];
  const form = forms[0];
  if (!form) return null;

  // Hidden container inside the form for the real file input
  const wrap = document.createElement("div");
  wrap.setAttribute("data-joiuss-rx-upload", "");
  wrap.style.display = "none";
  form.appendChild(wrap);

  // Prefer MOVING the existing UI file input (keeps any chosen file intact)
  const uiFileInput = uiRoot()?.querySelector('input[type="file"][data-rx-upload-input]');
  if (uiFileInput) {
    // Force the correct Shopify file property name
    uiFileInput.name = "properties[_Prescription Upload]";
    uiFileInput.accept = uiFileInput.accept || "image/*,.pdf";

    // Move into the form so Shopify actually receives the file
    wrap.appendChild(uiFileInput);

    return uiFileInput;
  }

  // Fallback: create a new real file input inside the form
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*,.pdf";
  input.name = "properties[_Prescription Upload]";
  input.setAttribute("data-rx-upload-input", "");
  wrap.appendChild(input);

  return input;
};



  // ============================================================
  // 2) STATE
  // ============================================================
const state = {
  mode: "frame",
  intent: null,
  use: null,
  type: null,
  colour: null,
  colour_preview: null,
  reader_power: null,
  bifocal_shape: null,  

  rx: {
    pd: null,          // null until user enters a value (63 default was bypassing PD validation)
    pd_mode: "binocular", // "binocular" | "mono"
    pd_r: null,
    pd_l: null,
    no_cyl: { r: false, l: false },
    add: null,
    prism_enabled: false,
    send_later: false,
    uploaded: false,
    rx_parsed: false,  // true once parse attempt completes (success or error) — reveals Rx fields
    pd_later: false,

    r: { sph: null, cyl: null, axis: null, near_sph: null, prism_h: null, base_h: "IN", prism_v: null, base_v: "UP"},
    l: { sph: null, cyl: null, axis: null, near_sph: null, prism_h: null, base_h: "IN", prism_v: null, base_v: "DOWN"}
  }
};

  // expose live state for debugging
  window.__JOIUSS_LENS_DEBUG__.state = state;


  // ============================================================
// RX Upload UI: "Send later" should disable + fade (not hide)
// ============================================================
const applySendLaterUI = () => {
  const on = !!state?.rx?.send_later;

  const btn = uploadChooseBtn();
  if (btn) btn.disabled = on;

  const wrap = uploadWrap();
  if (wrap) wrap.classList.toggle("is-disabled", on);
};


  const SWATCH_SETS = {
    blue_light: [
      { value: "Clear", dot: "#eceeeb" },
      { value: "Yellow", dot: "rgba(255,255,0,0.75)" },
      { value: "Red", dot: "rgba(255,0,0,0.72)" }
    ],
    sun: [
      { value: "Grey", dot: "grey" },
      { value: "Brown", dot: "#806666" },
      { value: "G-15 Green", dot: "green" }
    ],
    polarised: [
      { value: "Grey", dot: "grey" },
      { value: "Brown", dot: "#806666" },
      { value: "G-15", dot: "green" }
    ],
    trans: [
      { value: "Grey", dot_from: "#8080800c", dot_to: "grey" },
      { value: "Brown", dot_from: "#80666611", dot_to: "#806666" },
      { value: "S/Green", dot_from: "#dff0df", dot_to: "#0f4d0f" },
      { value: "Sapphire", dot_from: "#2195f311", dot_to: "#2195f3" },
      { value: "Amethyst", dot_from: "#eadcf0", dot_to: "#4a1363" },
      { value: "Emerald", dot_from: "#dff0df", dot_to: "#0f4d0f" },
      { value: "Amber", dot_from: "#ffe0b3", dot_to: "#9c5f00" },
      { value: "Ruby", dot_from: "#ffd2d2", dot_to: "#7c0000" }
    ]
  };

  const needsColour = (lensType) =>
    lensType === "blue_light" ||
    lensType === "sun" ||
    lensType === "polarised" ||
    lensType === "trans";

  const needsBifocalShape = () =>
    state.intent === "prescription" && state.use === "bifocal";

  const bifocalRequiresD28 = () =>
  state.use === "bifocal" &&
  (state.type === "polarised" || state.type === "trans");

  // If bifocal shape is R 24mm, we must hide Polarised + Transitions options
  const bifocalIsR24 = () =>
  state.intent === "prescription" &&
  state.use === "bifocal" &&
  String(state.bifocal_shape || "").trim() === "R 24mm";

  // ============================================================
  // 3) UI HELPERS
  // ============================================================
    const setPressed = (el, isOn) =>
        el && el.setAttribute("aria-pressed", isOn ? "true" : "false");

   const setSummaryText = (text) => {
  const root = uiRoot();
  if (!root) return;

  root.querySelectorAll("[data-joiuss-lens-summary-text]").forEach((el) => {
    el.textContent = String(text ?? "");
  });
};

// ============================================================
// Smooth scroll helper (luxury polish)
// ============================================================
const prefersReducedMotion = () =>
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const getStickyOffset = () => {
  const hw = document.querySelector(".header-wrapper");
  return hw ? hw.getBoundingClientRect().height + 12 : 12;
};

let LAST_SCROLLED_STEP = null;
let AUTO_SCROLLING = false;
let AUTO_SCROLL_TIMER = null;

const scrollToStep = (stepKey) => {
  const root = uiRoot();
  if (!root) return;

  const el = root.querySelector(`[data-step="${CSS.escape(stepKey)}"]`);
  if (!el) return;

  // Don't retrigger while smooth scroll is in-flight
  if (AUTO_SCROLLING) return;

  // Prevent repeat scroll spam
  if (LAST_SCROLLED_STEP === stepKey) return;

  const offset = getStickyOffset();
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight || document.documentElement.clientHeight;

  // If it's already comfortably visible, don't scroll
  if (rect.top > 0 && rect.top < vh * 0.6) {
    LAST_SCROLLED_STEP = stepKey;
    return;
  }

  const targetTop = Math.max(0, window.scrollY + rect.top - offset);

  // If we're already basically there, don't scroll
  if (Math.abs(window.scrollY - targetTop) < 8) {
    LAST_SCROLLED_STEP = stepKey;
    return;
  }

  LAST_SCROLLED_STEP = stepKey;
  AUTO_SCROLLING = true;
  clearTimeout(AUTO_SCROLL_TIMER);
  AUTO_SCROLL_TIMER = setTimeout(() => {
    AUTO_SCROLLING = false;
  }, 600);

  window.scrollTo({
    top: targetTop,
    behavior: prefersReducedMotion() ? "auto" : "smooth",
  });
};


  const setLineItemProperty = (name, value) => {
    const forms = getAllProductForms();
    if (!forms.length) return;

    forms.forEach((form) => {
      form
        .querySelector(`input[name="properties[${CSS.escape(name)}]"]`)
        ?.remove();

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      input.value = String(value ?? "");
      form.appendChild(input);
    });
  };

  const removeLineItemProperty = (name) => {
    getAllProductForms().forEach((form) => {
      form
        .querySelector(`input[name="properties[${CSS.escape(name)}]"]`)
        ?.remove();
    });
  };

  const writePrismProps = (eye) => {
  const side = eye.toUpperCase();

  // Horizontal prism
  if (!state.rx[eye].prism_h) {
    removeLineItemProperty(`Rx Prism Horizontal (${side})`);
    removeLineItemProperty(`Rx Base Horizontal (${side})`);
  } else {
    setLineItemProperty(
      `Rx Prism Horizontal (${side})`,
      String(state.rx[eye].prism_h)
    );
    setLineItemProperty(
      `Rx Base Horizontal (${side})`,
      state.rx[eye].base_h
    );
  }

  // Vertical prism
  if (!state.rx[eye].prism_v) {
    removeLineItemProperty(`Rx Prism Vertical (${side})`);
    removeLineItemProperty(`Rx Base Vertical (${side})`);
  } else {
    setLineItemProperty(
      `Rx Prism Vertical (${side})`,
      String(state.rx[eye].prism_v)
    );
    setLineItemProperty(
      `Rx Base Vertical (${side})`,
      state.rx[eye].base_v
    );
  }
};


  // ============================================================
// JOIUSS: Luxury slider helpers (Ready Readers first)
// ============================================================
    const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
    const setRangeFillPercent = (el) => {
      if (!el) return;
      const min = parseFloat(el.min || "0");
      const max = parseFloat(el.max || "100");
      const val = parseFloat(el.value || "0");

      if (!Number.isFinite(min) || !Number.isFinite(max) || max <= min) {
        el.style.setProperty("--fill-percent", "0%");
        return;
      }

      const pct = ((val - min) / (max - min)) * 100;
      el.style.setProperty("--fill-percent", `${Math.max(0, Math.min(100, pct))}%`);
    };


    const formatPower025 = (n) => {
    const v = Number(n || 0);
    const abs = Math.abs(v).toFixed(2);
    const sign = v >= 0 ? "+" : "-";
    return `${sign}${abs}`;
    };

    const setReaderPower = (val) => {
      const ro = readerReadout();

      const min = 0.25, max = 3.50, step = 0.25;
      const v = clamp(Number(val), min, max);

      // snap to 0.25
      const snapped = Math.round(v / step) * step;

      state.reader_power = Number(snapped.toFixed(2));
      state.reader_power_confirmed = true; // ✅ required for ATC gating

      if (ro) ro.textContent = formatPower025(state.reader_power);

      // Line item props (Ready Readers uses fixed PD 62)
      setLineItemProperty("Reader power", formatPower025(state.reader_power));
      setLineItemProperty("PD", "62");

      // Switch variant immediately so price + lens confirmation updates.
      maybeApplyRxRecommendation();
    };
// Tooltips
  const closeAllTooltips = () => {
    document.querySelectorAll("[data-tooltip]").forEach((t) => {
      t.classList.remove("is-open");
      t.hidden = true;
    });
  };

  const openTooltip = (tipId) => {
    const t = document.querySelector(`[data-tooltip="${CSS.escape(tipId)}"]`);
    if (!t) return;

    document.querySelectorAll("[data-tooltip]").forEach((other) => {
      if (other !== t) {
        other.classList.remove("is-open");
        other.hidden = true;
      }
    });

    t.hidden = false;
    requestAnimationFrame(() => t.classList.add("is-open"));
  };

  const toggleTooltip = (tipId) => {
    const t = document.querySelector(`[data-tooltip="${CSS.escape(tipId)}"]`);
    if (!t) return;

    const isOpen = !t.hidden;
    if (isOpen) {
      t.classList.remove("is-open");
      window.setTimeout(() => (t.hidden = true), 160);
    } else {
      openTooltip(tipId);
    }
  };


// ============================================================
// Dynamic colour tooltip copy (updates based on lens type + colour)
// ============================================================
const LENS_COLOUR_TOOLTIP_COPY = {
  blue_light: {
    __title: "JOIUSS™ Blue Light Block Guide",
    "Clear": {
      name: "Clear X BLUE BLOCK",
      desc: "Daytime wear for all devices when working or gaming in artificial light."
    },
    "Yellow": {
      name: "Yellow Lenses",
      desc: "May help some people with low mood, anxiety, mood swings and seasonal affective disorder (SAD) by boosting contrast and perceived brightness."
    },
    "Red": {
      name: "Red Lenses",
      desc: "Wear a few hours before bedtime to reduce blue light from lights and screens and support a restful sleep routine."
    },
    __note: "Style note: if you’re between colours, matching the lens tone to your frame usually looks the most intentional."
  },

  polarised: {
    __title: "Polarised Lens Tint Guide",
    "Grey Polarised": {
      name: "Grey Polarised",
      desc: "Cuts glare hard while keeping colours neutral. Great for driving, seaside days, and bright midday light."
    },
    "Brown Polarised": {
      name: "Brown Polarised",
      desc: "Boosts contrast and depth perception, often feels a touch ‘warmer’. Lovely for changeable UK light and driving."
    },
    "G-15 Polarised": {
      name: "G-15 Green/Grey Polarised",
      desc: "Classic green-grey tint that stays natural, comfortable, and very ‘heritage sunglasses’. Brilliant all-rounder."
    },
    __note: "Polarised lenses reduce harsh reflected glare (water, roads, glass). For the best aesthetics, choose a tint that complements your frame colour."
  },

  sun: {
    __title: "Sunglass Tint Guide",
    "Grey": {
      name: "Grey",
      desc: "Neutral tone, true-to-life colour. Best for strong daylight and a clean, modern look."
    },
    "Brown": {
      name: "Brown",
      desc: "Adds contrast and definition. Often feels more flattering in variable light and for driving."
    },
    "G-15 Green": {
      name: "G-15 Green/Grey",
      desc: "A timeless vintage tint with comfortable contrast and natural colour balance."
    },
    __note: "Style note: for the best aesthetics, match or complement your frame colour (warm frames love browns/ambers, cool frames love greys/greens)."
  },

  trans: {
    __title: "Transitions Colour Guide",
    "Grey": {
      name: "Grey",
      desc: "The most neutral, stays ‘true colour’ in bright sun. Easy to pair with any frame."
    },
    "Brown": {
      name: "Brown",
      desc: "Warm, contrast-enhancing, and often the most ‘golden-hour’ flattering."
    },
    "S/Green": {
      name: "Slate/Green",
      desc: "A modern green shift with a vintage nod. Great if you like a slightly moodier tint outdoors."
    },
    "Sapphire": {
      name: "Sapphire",
      desc: "Cool blue tone with a crisp look. Pairs beautifully with silver/black frames."
    },
    "Amethyst": {
      name: "Amethyst",
      desc: "Purple tone with a softer vibe. Stunning with black, tort, and gold accents."
    },
    "Emerald": {
      name: "Emerald",
      desc: "Lush green tone with a statement finish. Gorgeous with warm torts and gold detailing."
    },
    "Amber": {
      name: "Amber",
      desc: "Warm honey tone that feels vintage and cosy. Ideal for warm frames and soft sunlight."
    },
    "Ruby": {
      name: "Ruby",
      desc: "Bold red tone for maximum drama. Best when you want the lens colour to be part of the outfit."
    },
    __note: "Style note: for the best aesthetics, match or complement your frame colour. If you’re unsure, Grey is the safest all-rounder."
  }
};

    const updateLensColourTooltip = () => {
      const tip = document.querySelector('[data-tooltip="lens-colour"]');
      if (!tip) return;

      // If colour step is not relevant, keep the existing default copy (from Liquid)
      if (!needsColour(state.type)) return;

      const group = LENS_COLOUR_TOOLTIP_COPY[state.type];
      if (!group) return;

      const activeColour = state.colour_preview || state.colour;

      // Build a stable, UI-friendly order using the swatch set for the current type
      const ordered = (SWATCH_SETS[state.type] || [])
        .map(o => o.value)
        .filter(v => v && group[v]);

      // Helper: render a single colour block
      const renderEntry = (key, isActive) => {
        const entry = group[key];
        if (!entry) return "";
        return `
          <div class="joiuss-tip-item${isActive ? " is-active" : ""}" data-colour-tip="${key}">
            <div class="joiuss-tip-name"><strong>${entry.name || key}</strong></div>
            <div class="joiuss-tip-desc">${entry.desc || ""}</div>
          </div>
        `;
      };

      // If nothing is selected yet, show *all* colour guidance up-front (better UX)
      // If something is selected/previewed, show it first, then the rest.
      const parts = [];

      parts.push(`
        <div class="joiuss-tip-item">
          <div class="joiuss-tip-name"><strong>${group.__title || "Lens colour guide"}</strong></div>
          ${group.__note ? `<div class="joiuss-tip-desc" style="margin-top:4px; opacity:.9;">${group.__note}</div>` : ``}
        </div>
      `);

      if (activeColour && group[activeColour]) {
        parts.push(renderEntry(activeColour, true));
      }

      ordered.forEach((key) => {
        if (key === activeColour) return;
        parts.push(renderEntry(key, false));
      });

      // Fallback: if SWATCH_SETS is missing for some reason, render whatever is in the group
      if (ordered.length === 0) {
        Object.keys(group).forEach((k) => {
          if (k.startsWith("__")) return;
          if (k === activeColour) return;
          parts.push(renderEntry(k, false));
        });
      }

      tip.innerHTML = parts.join("");

      // If the tooltip is open and we're previewing a colour, ensure it's visible
      if (activeColour) {
        const activeEl = tip.querySelector(`[data-colour-tip="${CSS.escape(activeColour)}"]`);
        if (activeEl) activeEl.scrollIntoView({ block: "nearest" });
      }
    };

  const resetDownstreamAfterIntent = () => {
    state.use = null;
    state.type = null;
    state.colour = null;
    state.bifocal_shape = null;
    state.reader_power = null;
    state.reader_power_confirmed = false;
    state.rx = {
    pd: null,
    pd_mode: "binocular",
    pd_r: null,
    pd_l: null,
    no_cyl: { r: false, l: false },
    prism_enabled: false,
    send_later: false,
    uploaded: false,
    rx_parsed: false,
    pd_later: false,
    r: { sph: null, cyl: null, axis: null, near_sph: null, prism_h: null, base_h: "IN", prism_v: null, base_v: "UP" },
    l: { sph: null, cyl: null, axis: null, near_sph: null, prism_h: null, base_h: "IN", prism_v: null, base_v: "DOWN" }
    };

    removeLineItemProperty("Lens use");
    removeLineItemProperty("Lens type");
    removeLineItemProperty("Lens colour");
    removeLineItemProperty("Bifocal shape");
    removeLineItemProperty("Reader power");
    removeLineItemProperty("PD");
    [
      "PD",
      "Mono PD (R)",
      "Mono PD (L)",
      "Rx SPH (R)","Rx SPH (L)",
      "Rx CYL (R)","Rx CYL (L)",
      "Rx Axis (R)","Rx Axis (L)",
      "Rx ADD",
      "Rx Prism Horizontal (R)","Rx Base Horizontal (R)",
      "Rx Prism Vertical (R)","Rx Base Vertical (R)",
      "Rx Prism Horizontal (L)","Rx Base Horizontal (L)",
      "Rx Prism Vertical (L)","Rx Base Vertical (L)",
      "Prescription upload",
      "Prescription filename"
    ].forEach(removeLineItemProperty);

    stepUse()?.querySelectorAll("button[data-use]")?.forEach((b) => {
      b.classList.remove("is-active");
      b.setAttribute("aria-pressed", "false");
    });

    stepType()?.querySelectorAll("button[data-type]")?.forEach((b) => {
      b.classList.remove("is-active");
      b.setAttribute("aria-pressed", "false");
    });

    stepColour()?.querySelectorAll("button[data-swatch]")?.forEach((b) => {
      b.classList.remove("is-active");
      b.setAttribute("aria-pressed", "false");
    });

    bifocalWrap()
      ?.querySelectorAll("[data-bifocal-shape-btn]")
      ?.forEach((b) => b.classList.remove("is-active"));
    if (readerReadout()) readerReadout().textContent = "+0.25";
  };

  // ============================================================
// FULL RESET: used when switching lens paths (Mode/Intent)
// ============================================================
const resetAllLensSelectorState = () => {
  // Clear the downstream (use/type/colour/rx etc.)
  resetDownstreamAfterIntent();

  // Also clear top-level selection context
  state.intent = null;

  // Clear any lens-key mapping state in cart properties
  removeLineItemProperty("_Lens key");

  // Clear the summary line so we don't carry old labels across paths
  setSummaryText("");
  setLineItemProperty("Lens selection", "");

  // Always snap back to base variant (frame-only / master)
  try {
    switchToVariantIndex0();
  } catch (_) {}

  // Re-sync ATC lock/message based on fresh state
  try {
    clearOutOfRangeMessage();
  } catch (_) {}
  try {
    syncAtcLockToState();
  } catch (_) {}
};


  const getLabel = (selector) =>
    uiRoot()?.querySelector(selector)?.textContent?.trim() || "";

  // Track latest summary string so we can reuse it in helper copy
  let LAST_SUMMARY = "";

  // Keep summary in one place so ATC + UX stay coherent
  const updateSummaryFromState = () => {
    const parts = [];

    if (state.mode !== "custom") {
      parts.push("Frame only");
    } else {
      parts.push("Custom lenses");

      if (state.intent === "clear") parts.push("Clear fashion");
      if (state.intent === "prescription") parts.push("Prescription");
      if (state.intent === "ready_readers") parts.push("Ready Readers");
    }

    // Prescription subtype (Distance/Reading/Varifocal/Bifocal)
    if (state.intent === "prescription" && state.use) {
      const useLabel = getLabel(
        `[data-step="use"] button[data-use="${CSS.escape(state.use)}"]`
      );
      if (useLabel) parts.push(useLabel);
    }

    // Ready Readers extra summary
    if (state.intent === "ready_readers") {
      if (state.type) {
        const label =
          state.type === "clear" ? "Clear" :
          state.type === "blue_light" ? "Blue Light" :
          state.type === "sun" ? "Sunglasses" :
          state.type === "polarised" ? "Polarised" :
          state.type === "trans" ? "Transitions" :
          state.type;
        parts.push(label);
      }

      if (state.colour) parts.push(state.colour);

      if (state.reader_power != null) {
        parts.push(`Power ${formatPower025(state.reader_power)}`);
        parts.push("PD 62");
      }
    }

    // Bifocal shape (only when relevant + chosen)
    if (needsBifocalShape() && state.bifocal_shape) {
      parts.push(state.bifocal_shape);
    }
    

    // Lens option label (Clear / Blue Light / etc.)
    if (state.type) {
      const typeLabel = getLabel(
        `[data-step="type"] button[data-type="${CSS.escape(state.type)}"]`
      );
      if (typeLabel) parts.push(typeLabel);
    }

    if (state.colour) parts.push(state.colour);

    LAST_SUMMARY = parts.join(" · ");
    setSummaryText(LAST_SUMMARY);
  };

  // ============================================================
  // 4) ATC LOCKING
  // ============================================================
  const setAtcLocked = (locked, message) => {
    const btns = getAddToCartButtons();
    const helper = helperEl();
    if (!btns.length) return;

    btns.forEach((btn) => {
      if (btn.dataset.joiussOriginalDisabled == null) {
        btn.dataset.joiussOriginalDisabled = String(btn.disabled);
      }

      if (locked) {
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
        btn.dataset.joiussLocked = "1";
      } else {
        btn.dataset.joiussLocked = "0";
        btn.removeAttribute("aria-disabled");
        btn.disabled = btn.dataset.joiussOriginalDisabled === "true";
      }
    });

    if (helper) {
      if (locked) {
        const msg = String(message || "").trim();
        const summary = String(LAST_SUMMARY || "").trim();

        // Only show the helper if there's something useful to display
        if (msg || summary) {
          helper.hidden = false;
          helper.textContent = msg;
          if (summary) {
            if (msg) helper.appendChild(document.createElement("br"));
            const span = document.createElement("span");
            span.className = "joiuss-helper__selected";
            span.textContent = `Selected: ${summary}`;
            helper.appendChild(span);
          }
        } else {
          helper.hidden = true;
        }
      } else {
        helper.hidden = true;
      }
    }

    // ── Sticky mobile ATC bar ──
    // On mobile (max-width: 749px) mirror the first real ATC button into the
    // sticky bar so it is always reachable without scrolling.
    const stickyBar = uiRoot()?.querySelector("[data-joiuss-sticky-atc]");
    if (stickyBar) {
      const isMobile = window.matchMedia("(max-width: 749px)").matches;
      if (isMobile && btns.length) {
        const srcBtn = btns[0];
        // Clone the button so we don't move it from the form
        let mirrorBtn = stickyBar.querySelector("[data-joiuss-sticky-btn]");
        if (!mirrorBtn) {
          mirrorBtn = document.createElement("button");
          mirrorBtn.setAttribute("data-joiuss-sticky-btn", "");
          mirrorBtn.type = "button";
          // Forward click to the real ATC button so Shopify form logic fires
          mirrorBtn.addEventListener("click", () => {
            if (!srcBtn.disabled) srcBtn.click();
          });
          stickyBar.appendChild(mirrorBtn);
        }
        // Sync text, disabled state, and classes from the real button
        mirrorBtn.textContent = srcBtn.textContent || "Add to cart";
        mirrorBtn.disabled = srcBtn.disabled;
        mirrorBtn.className = srcBtn.className;
        stickyBar.hidden = false;
      } else {
        stickyBar.hidden = true;
      }
    }
  };

const rxIsComplete = () => {
  // Only gate on the Prescription path
  if (state.intent !== "prescription") return true;

  // Must have selected prescription type (use) + lens option (type)
  if (!state.use || !state.type) return false;

  // Helpers
  const hasVal = (v) => v != null && String(v).trim() !== "";
  const isNum = (v) => {
    const n = parseFloat(String(v ?? "").trim());
    return Number.isFinite(n);
  };

  // ----------------------------
  // 1) Required: SPH (R + L)
  // ----------------------------
  const rSphOk = hasVal(state.rx?.r?.sph);
  const lSphOk = hasVal(state.rx?.l?.sph);
  if (!rSphOk || !lSphOk) return false;

  // ----------------------------
  // 2) Required: PD (binocular OR mono) — OR pd_later checkbox ticked
  // ----------------------------
  const pdOk =
    state.rx.pd_later ||
    (state.rx.pd_mode === "mono"
      ? hasVal(state.rx.pd_r) && hasVal(state.rx.pd_l)
      : hasVal(state.rx.pd));

  if (!pdOk) return false;

  // ----------------------------
  // 3) Required: CYL + AXIS (per-eye) unless No CYL toggled for that eye
  // ----------------------------
  const eyeNeedsCylAxis = (eye) => !state.rx?.no_cyl?.[eye];

  const cylAxisOk = (eye) => {
    if (!eyeNeedsCylAxis(eye)) return true; // No CYL toggle = satisfied

    const cyl = state.rx?.[eye]?.cyl;
    const axis = state.rx?.[eye]?.axis;

    // Require both fields entered
    if (!hasVal(cyl) || !hasVal(axis)) return false;

    // Axis should be numeric (0–180); we just validate numeric here
    if (!isNum(axis)) return false;

    return true;
  };

  if (!cylAxisOk("r") || !cylAxisOk("l")) return false;

  // ----------------------------
  // 4) Required: ADD for multifocals (varifocal or bifocal)
  // ----------------------------
  const isMulti = state.use === "varifocal" || state.use === "bifocal";

  if (isMulti) {
    // Your code computes ADD from near_sph (Right) - dist sph (Right)
    // so ADD may be present even if the user never manually types it.
    const addOk = hasVal(state.rx.add) && isNum(state.rx.add);

    // Also accept a state where near_sph is present and sph is present (so ADD should compute)
    const nearOk = hasVal(state.rx?.r?.near_sph) && hasVal(state.rx?.r?.sph);

    if (!addOk && !nearOk) return false;
  }

  // ----------------------------
  // If all rules pass: Rx is complete
  // ----------------------------
  return true;
};



  const syncAtcLockToState = () => {
    const isCustom = state.mode === "custom";

    if (!isCustom) {
      setAtcLocked(false);
      return;
    }

    if (!state.intent) {
      setAtcLocked(true, "To continue, choose clear fashion, prescription or ready reading lenses.");
      return;
    }

    if (state.intent === "prescription" && !state.use) {
      setAtcLocked(true, "Choose your prescription type to continue.");
      return;
    }

    // NEW: bifocal shape required
    if (needsBifocalShape() && !state.bifocal_shape) {
      setAtcLocked(true, "Choose your bifocal shape to continue.");
      return;
    }

    if (!state.type) {
      setAtcLocked(true, "Choose your lens option to continue.");
      return;
    }

    if (needsColour(state.type) && !state.colour) {
      setAtcLocked(true, "Choose a colour to continue.");
      return;
    }

    // ✅ Send Later bypass: if the customer chose "I’ll send it later",
    // skip all Rx field validation and upload gating entirely.
    if (state.intent === "prescription" && state.rx.send_later) {
      // Fall through to setAtcLocked(false) below
    } else if (state.intent === "prescription" && !rxIsComplete()) {
      // Rx fields are incomplete — lock ATC silently (form itself guides the user)
      setAtcLocked(true, "");
      return;
    } else if (state.intent === "prescription") {
      // Rx fields complete — still need upload OR send_later
      const uploadOk = !!state.rx.send_later || !!state.rx.uploaded;
      if (!uploadOk) {
        setAtcLocked(true, "");
        return;
      }
    }


    // Ready Readers: require an explicit power confirmation (don’t assume defaults)
    if (state.intent === "ready_readers" && !state.reader_power_confirmed) {
      setAtcLocked(true, "Choose your reading power to continue.");
      return;
    }




    // ── PD "Last step" card: toggle completion state ──
    // Runs on every syncAtcLockToState() call so the card always reflects
    // the current PD state regardless of how it was satisfied.
    (() => {
      const pdCard  = uiRoot()?.querySelector("[data-pd-row]");
      const pdBadge = uiRoot()?.querySelector("[data-pd-badge]");
      if (!pdCard) return;

      const pdDone =
        !!state.rx.pd_later ||
        (state.rx.pd_mode === "mono"
          ? (state.rx.pd_r != null && state.rx.pd_l != null)
          : state.rx.pd != null);

      pdCard.classList.toggle("is-complete", pdDone);
      if (pdBadge) {
        pdBadge.textContent = pdDone ? "PD added \u2713" : "Last step \u2713";
      }
    })();

    setAtcLocked(false);
  };

  // ============================================================
  // 5) VARIANT SWITCHING
  // ============================================================
  const setVariantIdsInForms = (variantId) => {
    const v = String(variantId);
    getAllProductForms().forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      idInput.value = v;
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
      idInput.dispatchEvent(new Event("input", { bubbles: true }));
    });
  };

const updateUrl = (variantId) => {
  // IMPORTANT:
  // Dawn updates the URL itself when the variant <input name="id"> changes.
  // Calling history.replaceState here triggers a 3rd-party "legacy" script
  // that crashes with querySelector("").
  //
  // So: do nothing on Dawn to avoid the error.
  if (getProductInfo()) return Promise.resolve();

  // Fallback for non-Dawn themes only:
  const v = String(variantId);
  return Promise.resolve().then(() => {
    const u = new URL(window.location.href);
    u.searchParams.set("variant", v);
    window.history.replaceState({}, "", u.toString());
  }).catch(() => {});
};



const nudgeDawn = (variantId) => {
  const pi = getProductInfo();
  if (!pi) return;

  const v = String(variantId);

  try {
    // 1) Update Dawn's internal inputs if available
    if (typeof pi.updateVariantInputs === "function") {
      pi.updateVariantInputs(v);
    }

    // 2) Update URL safely (guards against data-url="undefined")
    // if (typeof pi.updateURL === "function") {
    //   const raw = (pi.dataset && typeof pi.dataset.url === "string") ? pi.dataset.url.trim() : "";
    //   const bad =
    //     !raw ||
    //     raw === "undefined" ||
    //     raw === "null" ||
    //     raw === "false" ||
    //     raw === "#";

    //   const baseUrl = bad ? window.location.pathname : raw;
    //   pi.updateURL(v, baseUrl);
    // }

    // 3) Trigger a REAL variant change via the product form input (most reliable in Dawn)
    const form =
      pi.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    const idInput = form ? form.querySelector('[name="id"]') : null;

    if (idInput) {
      // Only dispatch if value actually changes
      if (String(idInput.value) !== v) {
        idInput.value = v;
      }
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
      idInput.dispatchEvent(new Event("input", { bubbles: true }));
    } else {
      // Fallback: notify listeners something changed
      pi.dispatchEvent(new CustomEvent("change", { bubbles: true }));
    }

    // IMPORTANT:
    // Do NOT call pi.renderProductInfo / pi.handleUpdateProductInfo directly.
    // Those can trigger empty-selector querySelector crashes depending on theme/app state.
  } catch (e) {
    console.warn("[JOIUSS] Dawn nudge failed (safe):", e);
  }
};


// ============================================================
// 5B) PACKAGE INDEX VARIANT SWITCHING (your stable lens index)
//    - packageIndex 1  => SKU ends "-1" (or fallback position after Frame Only)
//    - packageIndex 2  => SKU ends "-2"
// ============================================================

const getVariantsJson = () => {
  const tag = document.querySelector('[data-joiuss-variants]');
  if (!tag) return [];
  try { return JSON.parse(tag.textContent || "[]") || []; }
  catch (_) { return []; }
};

// First try: find by SKU suffix "-<packageIndex>"
// Fallback: use position, skipping a leading "Frame Only" variant if present
const findVariantIdByPackageIndex = (packageIndex) => {
  const variants = getVariantsJson();
  if (!variants.length) return null;

  const n = Number(packageIndex);
  if (!Number.isFinite(n) || n < 0) return null;

  // 1) Prefer SKU suffix match (most explicit)
  const end = `-${n}`;
  const bySku = variants.find(v => String(v?.sku || "").trim().endsWith(end));
  if (bySku?.id) return String(bySku.id);

  // 2) Fallback to position mapping (skip Frame Only if it's first)
  const firstTitle = String(variants[0]?.title || "").toLowerCase();
  const firstSku = String(variants[0]?.sku || "");
  const hasFrameOnlyFirst =
    firstTitle.includes("frame only") ||
    (!firstSku.trim().endsWith("-0") && !firstSku.trim().match(/-\d+$/));

  const offset = hasFrameOnlyFirst ? 1 : 0;

  // packageIndex 1 should map to variants[offset + 0]
  const idx = offset + (n - 1);
  const v = variants[idx];
  return v?.id ? String(v.id) : null;
};

// Switch to the very first variant (index 0) = Frame Only
const switchToVariantIndex0 = () => {
  const variants = getVariantsJson();
  const v0 = variants?.[0]?.id ? String(variants[0].id) : null;
  if (!v0) {
    console.warn("[JOIUSS] No variants found to switch to index 0");
    return false;
  }

  setVariantIdsInForms(v0);
  updateUrl(v0);
  nudgeDawn(v0);
  return true;
};


const switchToPackageIndex = (packageIndex) => {
  const variantId = findVariantIdByPackageIndex(packageIndex);

  if (!variantId) {
    console.warn("[JOIUSS] No variant found for packageIndex:", packageIndex);
    return false;
  }

  // This already updates ALL add-to-cart forms (including Dawn product-form)
  setVariantIdsInForms(String(variantId));

  // Keep URL + Dawn product-info in sync
  updateUrl(String(variantId));
  nudgeDawn(String(variantId));

  return true;
};


// ============================================================
// NON-RX VARIANT SWITCHING (Clear fashion + Ready Readers)
// Switches variant by lens type keywords in variant title/SKU.
// Does NOT run on prescription (Rx uses package gating).
// ============================================================

const LENS_TYPE_KEYWORDS = {
  clear: ["clear", "standard", "classic", "fashion"],
  blue_light: ["blue", "bluelight", "blue light"],
  polarised: ["polar", "polarised", "polarized"],
  sun: ["sun", "sunglass", "sunglasses", "tint", "tinted"],
  trans: ["trans", "transition", "transitions", "photochromic"]
};

const normalizeLensType = (t) => {
  const v = String(t || "").trim().toLowerCase();

  // common alias fixes (Liquid/UI sometimes uses different naming)
  if (v === "blue" || v === "bluelight" || v === "blue-light") return "blue_light";
  if (v === "transition" || v === "transitions" || v === "photochromic") return "trans";
  if (v === "polarized") return "polarised";
  if (v === "sunglasses" || v === "tint" || v === "tinted") return "sun";

  return v;
};


const findVariantIdByLensType = (lensType) => {
  const variants = getVariantsJson();
  if (!variants?.length) return null;

  const type = String(lensType || "").toLowerCase();
  const keys = LENS_TYPE_KEYWORDS[type] || [];
  if (!keys.length) return null;

  const norm = (s) => String(s || "").toLowerCase();
  const hayFor = (v) => `${norm(v.title)} ${norm(v.public_title)} ${norm(v.sku)}`;

  // Special-case "clear" so it doesn't get stuck on the last clicked variant
  // Clear should ALWAYS map to packageIndex 1 (first lens variant after Frame Only)
  if (type === "clear") {
    const vId = findVariantIdByPackageIndex(1);
    return vId ? String(vId) : null;
  }


  const hit = variants.find((v) => keys.some((k) => hayFor(v).includes(String(k).toLowerCase())));
  return hit?.id ? String(hit.id) : null;
};

const maybeApplyNonRxLensTypeVariant = () => {
  // Only for non-Rx intents (frame-only / clear lenses)
  // NOTE: Ready Readers uses package-index switching and must NOT be overridden here.
  if (state.intent !== "clear") return;

  // Must have a type selected
  if (!state.type) return;

  const variantId = findVariantIdByLensType(state.type);
  if (!variantId) return;

  // Reuse your existing mechanism for actually switching the form variant
  setVariantIdsInForms(String(variantId));
  updateUrl(String(variantId));

  const addForm =
    document.querySelector('form[action^="/cart/add"]') ||
    document.querySelector('product-form form');

  const idInput = addForm?.querySelector('input[name="id"]');
  if (idInput) {
    idInput.value = String(variantId);
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
};

window.JOIUSS_TEST_SWITCH = (n) => switchToPackageIndex(n);


  // ============================================================
  // 6) SWATCH RENDER
  // ============================================================
  const renderSwatches = () => {
    const grid = swatchGrid();
    if (!grid) return;

    grid.innerHTML = "";

    if (!needsColour(state.type)) return;

    const list = SWATCH_SETS[state.type] || [];
        list.forEach((s) => {
      // Wrapper so the colour NAME can open a tooltip without also selecting the swatch.
      const item = document.createElement("div");
      item.className = "joiuss-swatch-item";

      // 1) Dot button = selects the colour
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "joiuss-swatch-btn";
      btn.setAttribute("data-swatch", s.value);

      // Direct binding on pointerdown so other scripts intercepting click can
      // never prevent selection. Also handles keyboard activation.
      const selectSwatch = (e) => {
        try {
          e.preventDefault();
          // Stop as early as possible (some global handlers swallow events)
          e.stopImmediatePropagation();
          e.stopPropagation();
        } catch (_) {}

        // Ensure we scope updates to the correct instance (Theme Editor duplicates)
        const root = btn.closest("[data-joiuss-lens]");
        if (root) ACTIVE_ROOT = root;

        state.colour = s.value;
        state.colour_preview = null;
        setLineItemProperty("Lens colour", state.colour);

        closeAllTooltips();
        render();
        maybeApplyRxRecommendation();
        maybeApplyNonRxLensTypeVariant();
      };

      btn.addEventListener("pointerdown", selectSwatch, true);
      btn.addEventListener("mousedown", selectSwatch, true);
      btn.addEventListener("touchstart", selectSwatch, { capture: true, passive: false });
      btn.addEventListener(
        "keydown",
        (e) => {
          if (e.key === "Enter" || e.key === " ") selectSwatch(e);
        },
        true
      );

      btn.setAttribute("aria-pressed", state.colour === s.value ? "true" : "false");
      if (state.colour === s.value) btn.classList.add("is-active");

      const dot = document.createElement("span");
      dot.className = "joiuss-swatch-dot";

      if (s.dot_from && s.dot_to) {
        dot.style.background = `linear-gradient(135deg, ${s.dot_from} 0%, ${s.dot_to} 100%)`;
      } else if (s.dot_border) {
        dot.style.background = s.dot;
        dot.style.border = `2px solid ${s.dot_border}`;
      } else {
        dot.style.background = s.dot;
      }

      btn.appendChild(dot);

     // 2) Label text only (no per-swatch tooltip icon)
const label = document.createElement("div");
label.className = "joiuss-swatch-label";
label.innerHTML = `<span class="joiuss-swatch-labelText">${s.value}</span>`;

item.appendChild(btn);
item.appendChild(label);
grid.appendChild(item);

    });
  };


  // ============================================================
  // 7) RENDER
// ============================================================
const render = () => {
  const root = uiRoot();
  if (!root) return;

    // ------------------------------------------------------------
  // Scroll gating: capture previous hidden state BEFORE we reset
  // ------------------------------------------------------------
  const __prevHidden = {
    type: stepType()?.hidden ?? true,
    colour: stepColour()?.hidden ?? true,
    rx: stepRx()?.hidden ?? true,
    reader_power: stepReaderPower()?.hidden ?? true,
  };

  const setStepVisibility = (el, shouldShow, stepKeyForScroll) => {
    if (!el) return;

    // Apply visibility
    el.hidden = !shouldShow;

    // Scroll only when the step transitions hidden -> visible
    if (
      shouldShow &&
      stepKeyForScroll &&
      __prevHidden[stepKeyForScroll] === true
    ) {
      scrollToStep(stepKeyForScroll);
    }
  };


  // Mode pills
  modeWrap()?.querySelectorAll('button[data-mode]')?.forEach((b) => {
    const on = b.getAttribute("data-mode") === state.mode;
    b.classList.toggle("is-active", on);
    setPressed(b, on);
  });

  const isCustom = state.mode === "custom";

  // Panel visibility
  if (frameNote()) frameNote().hidden = isCustom;
  if (customPanel()) customPanel().hidden = !isCustom;

  // Default: hide steps
  if (stepUse()) stepUse().hidden = true;
  if (stepType()) stepType().hidden = true;
  if (stepColour()) stepColour().hidden = true;
  if (stepReaderPower()) stepReaderPower().hidden = true;
  if (stepRx()) stepRx().hidden = true;
  if (uploadRow()) uploadRow().hidden = true;


  // Bifocal panel hidden by default
  if (bifocalWrap()) bifocalWrap().hidden = true;

  // ------------------------------------------------------------
  // Step sequencing (ONLY when Custom mode + an intent is chosen)
  // ------------------------------------------------------------
  if (isCustom && state.intent) {
  if (state.intent === "prescription") {
  const hasUse = !!state.use;

  // Keep "Prescription type" visible (like other pill steps)
  if (stepUse()) stepUse().hidden = false;


  // Show bifocal shape only once Use is chosen (and only if bifocal)
  if (bifocalWrap()) bifocalWrap().hidden = !(hasUse && needsBifocalShape());

  // Type step only after use chosen (and bifocal shape chosen when required)
  const hasBifocalOK = !needsBifocalShape() || !!state.bifocal_shape;

  // Type step (Lens option) only visible once a Prescription type has been chosen
  setStepVisibility(stepType(), hasUse, "type");


  // ------------------------------------------------------------
    // Bifocal rule: if shape is R 24mm, hide Polarised + Transitions
    // and invalidate any already-selected restricted option.
    // ------------------------------------------------------------
    const typeStep = stepType();
    if (typeStep) {
      const restrict = bifocalIsR24();

      // Hide restricted buttons
      const polarBtn = typeStep.querySelector('button[data-type="polarised"]');
      const transBtn = typeStep.querySelector('button[data-type="trans"]');

      if (polarBtn) polarBtn.hidden = restrict;
      if (transBtn) transBtn.hidden = restrict;

      // If the user previously picked one of these, clear it safely
      if (restrict && (state.type === "polarised" || state.type === "trans")) {
        state.type = null;
        state.colour = null;

        removeLineItemProperty("Lens type");
        removeLineItemProperty("Lens colour");
      }
    }

  const hasType = !!state.type;
  const needsCol = hasType && needsColour(state.type);

setStepVisibility(stepColour(), (hasType && needsCol), "colour");

  if (hasType && needsCol) renderSwatches();

  // Rx entry after type chosen and (if needed) colour chosen
const readyForRx = hasType && (!needsCol || !!state.colour);

setStepVisibility(stepRx(), readyForRx, "rx");


// Keep the form file input available only when RX is active
if (readyForRx) ensureRxUploadInput();

// Upload row visibility: show as soon as Rx step is active (before Rx fields)
const showUpload =
  readyForRx &&
  state.intent === "prescription";

const u = uploadRow();
if (u) u.hidden = !showUpload;

// Rx fields wrapper:
// - Shown only when: prescription has been uploaded+parsed AND send_later is NOT active
// - Hidden when: send_later is ticked (fast checkout), OR not yet parsed, OR non-prescription path
const rxFieldsWrap = uiRoot()?.querySelector('[data-rx-fields-wrap]');
if (rxFieldsWrap) {
  // On the prescription path: show only after a parse attempt AND only if not send_later
  // On any other path (frame only etc): always show (showUpload is false)
  rxFieldsWrap.hidden = showUpload && (!state.rx.rx_parsed || state.rx.send_later);
}

// PD later: sync checkbox and input wrap visibility to state
const pdLaterCb = uiRoot()?.querySelector('[data-rx-toggle="pd_later"]');
if (pdLaterCb) pdLaterCb.checked = !!state.rx.pd_later;
const pdInputWrap = uiRoot()?.querySelector('[data-pd-input-wrap]');
if (pdInputWrap) pdInputWrap.hidden = !!state.rx.pd_later;

// no_cyl: re-sync checkbox checked state AND cylAxis disabled state from state
// This ensures the UI is correct after render() is called from any code path
// (e.g. after use-change, autofill, or page re-render in Theme Editor).
["r", "l"].forEach((eye) => {
  const on = !!state.rx?.no_cyl?.[eye];
  const cb = uiRoot()?.querySelector(`[data-rx-toggle="no_cyl"][data-eye="${eye}"]`);
  if (cb) cb.checked = on;
  const eyeBlock = stepRx()?.querySelector(`[data-rx-cylaxis][data-eye="${eye}"]`);
  if (eyeBlock) eyeBlock.classList.toggle("is-disabled", on);
});

// Price expectation notice: show only when send_later is active
const sendLaterNotice = uiRoot()?.querySelector('[data-send-later-notice]');
if (sendLaterNotice) {
  sendLaterNotice.hidden = !(showUpload && state.rx.send_later);
}

// If upload row is visible, apply send-later UI (disable + fade).
// If upload row isn't visible, ensure it's reset.
if (showUpload) {
  applySendLaterUI();
} else {
  const btn = uploadChooseBtn();
  if (btn) btn.disabled = false;

  const wrap = uploadWrap();
  if (wrap) wrap.classList.remove("is-disabled");
}

  // Multifocal helper only when varifocal/bifocal selected
  stepRx()
    ?.querySelectorAll("[data-rx-multi]")
    ?.forEach((el) => (el.hidden = !(state.use === "varifocal" || state.use === "bifocal")));
}
 else if (state.intent === "ready_readers") {
      // Ready Readers flow:
      // - No "Prescription type" (use) step
      // - Lens option (type) always shown
      // - Colour shown only when needed
      // - Power slider only after type (+ colour if needed)

      if (stepUse()) stepUse().hidden = true;
      if (stepType()) stepType().hidden = false;
      if (bifocalWrap()) bifocalWrap().hidden = true;

      const hasType = !!state.type;

      // Colour only when required by chosen lens option
      if (stepColour()) stepColour().hidden = !(hasType && needsColour(state.type));
      if (hasType && needsColour(state.type)) renderSwatches();

      // Power slider only after Type is chosen, and (if needed) Colour chosen
      const readyForPower =
        hasType && (!needsColour(state.type) || !!state.colour);

setStepVisibility(stepReaderPower(), readyForPower, "reader_power");
      // Keep readout synced when it becomes visible
      if (readyForPower) {
        if (state.reader_power != null) {
          if (readerReadout()) readerReadout().textContent = formatPower025(state.reader_power);
        } else {
          if (readerReadout()) readerReadout().textContent = "+0.25";
        }
      }

      if (stepRx()) stepRx().hidden = true;


    } else {
  // Clear fashion flow
  if (stepType()) stepType().hidden = false;
  if (stepRx()) stepRx().hidden = true;
  if (uploadRow()) uploadRow().hidden = true;
}


    // Global colour handler (skip, because ready_readers already handles colour)
    if (state.intent !== "ready_readers" && state.type && needsColour(state.type)) {
      if (stepColour()) stepColour().hidden = false;
      renderSwatches();
    }
  }

  // Pressed states for Intent (lens path)
  uiRoot()
  ?.querySelectorAll("button[data-intent]")
  ?.forEach((b) => {
    const on = b.getAttribute("data-intent") === state.intent;
    b.classList.toggle("is-active", on);
    setPressed(b, on);
  });


  // Pressed states for Use
  stepUse()?.querySelectorAll("button[data-use]")?.forEach((b) => {
    const on = b.getAttribute("data-use") === state.use;
    b.classList.toggle("is-active", on);
    setPressed(b, on);
  });

  // Pressed states for Type
  stepType()?.querySelectorAll("button[data-type]")?.forEach((b) => {
    const on = b.getAttribute("data-type") === state.type;
    b.classList.toggle("is-active", on);
    setPressed(b, on);
  });

  // Pressed states for swatches
  stepColour()?.querySelectorAll('button[data-swatch]')?.forEach((b) => {
    const on = b.getAttribute("data-swatch") === state.colour;
    b.classList.toggle("is-active", on);
    setPressed(b, on);
  });

  // Pressed states for bifocal shape buttons
  bifocalWrap()
    ?.querySelectorAll("[data-bifocal-shape-btn]")
    ?.forEach((b) => {
      const on = b.getAttribute("data-value") === state.bifocal_shape;
      b.classList.toggle("is-active", on);
    });

  updateSummaryFromState();
  updateLensColourTooltip();
  syncAtcLockToState();
};

    // ============================================================
    // 7B) RX RECOMMENDATION → SKU SUFFIX (order-proof)
    // ============================================================

    const num = (v) => {
      const n = parseFloat(String(v ?? "").trim());
      return Number.isFinite(n) ? n : null;
    };

    const maxAbs = (arr) => Math.max(...arr.map(x => Math.abs(Number(x || 0))));

    const recommendPackageSuffixFromState = () => {
      // TINY TEST RULE: Prescription + single_gv + clear => package 1

      // Prescription + Ready Readers both use package gating
      if (state.intent !== "prescription" && state.intent !== "ready_readers") return null;
      

      // -------------------------------------------------
      // READY READERS (Custom Lenses > Ready Readers)
      // Use the SAME package rules as single-vision reading,
      // but derive "power" from the ready-reader slider.
      // This lets +2.25/+2.50/etc auto-jump to the thinner
      // packages exactly like the prescription path.
      // -------------------------------------------------
      if (state.intent === "ready_readers") {
        if (!state.type) return null;
        const rp = num(state.reader_power);
        if (rp == null) return null;

        const use = "reading";           // treat as SV reading
        const type = state.type;         // clear | sun | trans | blue_light | polarised
        const seg = "";
        const add = 0;

        const maxPowerSv = Math.abs(rp);
        const maxPowerMf = Math.abs(rp);
        const maxCyl = 0;

        console.log("[JOIUSS MAP][RR]", { use, type, maxPowerSv, maxCyl, maxPowerMf, seg, add });

        // SINGLE VISION (distance/reading) block (copied logic path)
        // -----------------------------
        if (use === "distance" || use === "reading") {

          // CLEAR
          if (type === "clear" && maxCyl <= 2.0) {
            if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 1;
            if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 2;
            if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 3;
            return null;
          }

          if (type === "clear" && maxCyl <= 4.0) {
            if (maxPowerSv > 2.0 && maxPowerSv <= 4.75) return 36;
            if (maxPowerSv > 4.75 && maxPowerSv <= 16.0) return 37;
            return null;
          }

          // BLUE LIGHT
          if (type === "blue_light" && maxCyl <= 2.0) {
            if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 8;
            if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 9;
            if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 10;
            return null;
          }

          if (type === "blue_light" && maxCyl <= 4.0) {
            if (maxPowerSv > 2.0 && maxPowerSv <= 4.75) return 38;
            if (maxPowerSv > 4.75 && maxPowerSv <= 16.0) return 39;
            return null;
          }

          // POLARISED
          if (type === "polarised" && maxCyl <= 2.0) {
            if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 11;
            if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 12;
            if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 35;
            return null;
          }

          // SUN
          if (type === "sun" && maxCyl <= 2.0) {
            if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 16;
            if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 17;
            if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 18;
            return null;
          }

          // TRANSITIONS
          if (type === "trans" && maxCyl <= 2.0) {
            if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 6;
            if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 7;
            if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 20;
            return null;
          }

          return null;
        }

        return null;
      }

// Prescription needs use + type.
      if (state.intent === "prescription") {
        if (!state.use || !state.type) return null;
      }

    // SPH can be blank at first: treat as 0 so "≤ 2.00" packages can be selected
    let sphR = num(state.rx?.r?.sph);
    let sphL = num(state.rx?.l?.sph);

    if (sphR == null) sphR = 0;
    if (sphL == null) sphL = 0;


      // CYL can be "None" per-eye
      const cylR = state.rx.no_cyl.r ? 0 : (num(state.rx.r.cyl) ?? 0);
      const cylL = state.rx.no_cyl.l ? 0 : (num(state.rx.l.cyl) ?? 0);

      // ADD (for reading totals + multifocals); default 0 if absent
      const add = num(state.rx.add) ?? 0;

      // Old logic uses max of:
      // totSphR/L = abs(sph + cyl)
      // abs sph/cyl
      // totReadR/L = sph + add
      const totSphR = Math.abs(sphR + cylR);
      const totSphL = Math.abs(sphL + cylL);
      const totReadR = sphR + add;
      const totReadL = sphL + add;

      // Absolute max values used for lens selection logic
      const sphAbsMax = Math.max(Math.abs(sphR ?? 0), Math.abs(sphL ?? 0));
      const cylAbsMax = Math.max(Math.abs(cylR ?? 0), Math.abs(cylL ?? 0));

      const powerS = [
        totSphR, totSphL,
        Math.abs(sphR), Math.abs(cylR),
        Math.abs(sphL), Math.abs(cylL),
        Math.abs(totReadR), Math.abs(totReadL)
      ];
      const powerM = [
        totSphR, totSphL,
        Math.abs(sphR), Math.abs(cylR),
        Math.abs(sphL), Math.abs(cylL)
      ];

      let maxPowerSv = Math.max(...powerS);
      let maxPowerMf = Math.max(...powerM);
      let maxCyl = Math.max(Math.abs(cylR), Math.abs(cylL));

      // Map your new UI use values to the old logic labels
      let use =
        state.use === "single_gv" ? "distance" :
        state.use === "single_nv" ? "reading"  :
        state.use;
             // distance | reading | bifocal | varifocal
      let type = state.type;           // clear | sun | trans | blue_light | polarised
      let seg = String(state.bifocal_shape || ""); // "D 28mm" / "R 24mm"

      console.log("[JOIUSS MAP]", { use, type, maxPowerSv, maxCyl, maxPowerMf, seg, add });


      // -----------------------------
      // SINGLE VISION (distance/reading)
      // -----------------------------
      if (use === "distance" || use === "reading") {

        // CLEAR
        if (type === "clear" && maxCyl <= 3.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 2.50) return 1;
          if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 2;
          if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 3;
          return null;
        }

        if (type === "clear" && maxCyl <= 4.0) {
          if (maxPowerSv <= 12.0) return 37;
          return null;
        }

        if (type === "clear" && maxCyl > 4.0) {
          if (maxPowerSv <= 18.0) return 38;
          return null;
        }

        // SUN
        if (type === "sun" && maxCyl <= 4.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 4;
          if (maxPowerSv > 2.5 && maxPowerSv <= 12.0) return 5;
          return null;
        }
        if (type === "sun" && maxCyl > 4.0) return null;

        // TRANSITIONS
        if (type === "trans" && maxCyl <= 2.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 6;
          if (maxPowerSv > 2.5 && maxPowerSv <= 5.0) return 7;
          if (maxPowerSv > 5.0 && maxPowerSv <= 10.0) return 39;
          return null;
        }
        if (type === "trans" && maxCyl <= 4.0) {
          if (maxPowerSv > 0.0 && maxPowerSv <= 10.0) return 7;
          return null;
        }
        if (type === "trans" && maxCyl <= 6.0) {
          if (maxPowerSv > 0.0 && maxPowerSv <= 10.0) return 39;
          return null;
        }

        // BLUE LIGHT
        if (type === "blue_light" && maxCyl <= 2.5) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 2.50) return 8;
          if (maxPowerSv > 2.5 && maxPowerSv <= 4.75) return 9;
          if (maxPowerSv > 4.75 && maxPowerSv <= 12.0) return 10;
          return null;
        }
        if (type === "blue_light" && maxCyl <= 4.0) {
          if (maxPowerSv <= 12.0) return 42;
          return null;
        }
        if (type === "blue_light" && maxCyl <= 6.0) {
          if (maxPowerSv <= 18.0) return 43;
          return null;
        }

        // POLARISED
        if (type === "polarised" && maxCyl <= 2.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 2.5) return 11;
          if (maxPowerSv > 2.50 && maxPowerSv <= 9.5) return 12;
          return null;
        }
        if (type === "polarised" && maxCyl <= 4.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 10.0) return 12;
          return null;
        }
        if (type === "polarised" && maxCyl <= 6.0) {
          if (maxPowerSv >= 0.0 && maxPowerSv <= 10.0) return 41;
          return null;
        }
      }

      // -----------------------------
      // BIFOCAL
      // -----------------------------
      if (use === "bifocal") {

        // CLEAR
        if (type === "clear" && seg.includes("D 28")) {
          if (maxCyl <= 2.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 13;
            if (maxPowerMf > 2.5 && maxPowerMf <= 10.0) return 14;
            return null;
          }
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 10.0) return 14;
            return null;
          }
          return null;
        }

        if (type === "clear" && seg.includes("R 24")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 10.0) return 15;
            return null;
          }
          return null;
        }

        // SUN
        if (type === "sun" && seg.includes("D 28")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 16;
            if (maxPowerMf > 3.0 && maxPowerMf <= 10.0) return 17;
            return null;
          }
          return null;
        }
        if (type === "sun" && seg.includes("R 24")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 10.0) return 18;
            return null;
          }
          return null;
        }

        // TRANSITIONS
        if (type === "trans" && seg.includes("D 28")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 8.0 && add <= 3.0) return 19;
            return null;
          }
          return null;
        }

        // POLARISED
        if (type === "polarised" && seg.includes("D 28")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 6.0) return 21;
            return null;
          }
          return null;
        }
        if (type === "polarised" && seg.includes("R 24")) return null;

        // BLUE LIGHT
        if (type === "blue_light" && seg.includes("D 28")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 31;
            if (maxPowerMf > 2.0 && maxPowerMf <= 10.0) return 32;
            return null;
          }
          return null;
        }
        if (type === "blue_light" && seg.includes("R 24")) {
          if (maxCyl <= 4.0) {
            if (maxPowerMf >= 0.0 && maxPowerMf <= 10.0) return 33;
            return null;
          }
          return null;
        }
      }

      // -----------------------------
      // VARIFOCAL
      // -----------------------------
      if (use === "varifocal") {

        if (type === "clear") {
          if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 22;
          if (maxPowerMf > 2.5 && maxPowerMf <= 5.0) return 23;
          if (maxPowerMf > 5.0 && maxPowerMf <= 16.0) return 24;
          return null;
        }

        if (type === "sun") {
          if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 25;
          if (maxPowerMf > 2.5 && maxPowerMf <= 10.0) return 26;
          return null;
        }

        if (type === "trans") {
          if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 27;
          if (maxPowerMf > 2.5 && maxPowerMf <= 12.0) return 28;
          return null;
        }

        if (type === "polarised") {
          if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 29;
          if (maxPowerMf > 2.5 && maxPowerMf <= 12.0) return 30;
          return null;
        }

        if (type === "blue_light") {
          if (maxPowerMf >= 0.0 && maxPowerMf <= 2.5) return 34;
          if (maxPowerMf > 2.5 && maxPowerMf <= 12.0) return 35;
          return null;
        }
      }

      return null;
    };

    // Apply recommendation whenever the state becomes “complete enough”

// ============================================================
// 7C) PRESCRIPTION DEFAULT PACKAGE INDEX (instant price reveal)
// If Rx values aren't entered yet, we still want to switch the
// product variant to the *entry-level* package for that option
// so the customer immediately sees the correct price + lens type.
//
// This fallback only runs on the Prescription path.
// Once SPH/PD etc are entered, the real Rx recommendation logic
// will override this default automatically.
// ============================================================

const DEFAULT_RX_PACKAGE_INDEX = {
  // state.use: single_gv | single_nv | varifocal | bifocal
  single_gv: {
    clear: 1,
    blue_light: 8,
    polarised: 11,
    sun: 16,
    trans: 6
  },
  single_nv: {
    clear: 1,
    blue_light: 8,
    polarised: 11,
    sun: 16,
    trans: 6
  },
  varifocal: {
    clear: 22,
    blue_light: 34,
    polarised: 29,
    sun: 25,
    trans: 27
  },
  bifocal: {
    "D 28mm": {
      clear: 13,
      blue_light: 31,
      polarised: 21,
      sun: 16,
      trans: 19
    },
    "R 24mm": {
      clear: 15,
      blue_light: 33,
      sun: 18
    }
  }
};


// Ready Readers uses the same "entry level" defaults as single-vision reading/computer.
const DEFAULT_READY_READER_PACKAGE_INDEX = {
  clear: 1,
  blue_light: 8,
  polarised: 11,
  sun: 16,
  trans: 6
};

const getDefaultRxPackageIndex = () => {
  if (state.intent !== "prescription" && state.intent !== "ready_readers") return null;

  // Need enough info to choose the default.
  if (state.intent === "prescription") {
    if (!state.use || !state.type) return null;
  } else {
    if (!state.type) return null;
  }

  // For bifocals (prescription only), shape is required before we can pick a default.
  if (state.intent === "prescription" && needsBifocalShape() && !state.bifocal_shape) return null;

  const type = String(state.type || "");

  // Ready Readers: no "use" step, so we just use the SV reading defaults.
  if (state.intent === "ready_readers") {
    return DEFAULT_READY_READER_PACKAGE_INDEX?.[type] ?? null;
  }

  const use = String(state.use || "");
  const seg = String(state.bifocal_shape || "").trim();

  if (use === "bifocal") {
    return DEFAULT_RX_PACKAGE_INDEX.bifocal?.[seg]?.[type] ?? null;
  }

  return DEFAULT_RX_PACKAGE_INDEX?.[use]?.[type] ?? null;
};

const CONTACT_URL = "/pages/contact"; // change if your contact page URL differs

// Low-range detection used for auto-default behaviour (<= 2.00 cyl)
const rxIsLowRangeForAutoDefault = () => {
  const cylR = num(state.rx?.r?.cyl);
  const cylL = num(state.rx?.l?.cyl);

  // If no cyl entered yet, treat as low-range for UX defaults
  const anyCyl = [cylR, cylL].some(v => v != null);
  if (!anyCyl) return true;

  const maxCylAbs = Math.max(Math.abs(cylR || 0), Math.abs(cylL || 0));
  return maxCylAbs <= 2.00;
};


const rxLooksCompleteEnoughToJudgeRange = () => {
  if (state.intent !== "prescription") return false;
  if (!state.use || !state.type) return false;

  const hasSomeSph =
    (state.rx?.r?.sph != null && String(state.rx.r.sph).trim() !== "") ||
    (state.rx?.l?.sph != null && String(state.rx.l.sph).trim() !== "");

  return hasSomeSph;
};

// True out-of-range detection (prevents false "out of range" loops)
const isRxOutOfRange = () => {
  // Only judge ranges for prescription intent
  if (state.intent !== "prescription") return false;

  const sphR = num(state.rx?.r?.sph);
  const sphL = num(state.rx?.l?.sph);
  const cylR = num(state.rx?.r?.cyl);
  const cylL = num(state.rx?.l?.cyl);

  // If nothing numeric yet, do NOT call it out-of-range
  const anyNumeric = [sphR, sphL, cylR, cylL].some(v => v != null);
  if (!anyNumeric) return false;

  // Set these to match your lab limits (edit if needed)
  const MAX_SPH = 10.00; // example: -10.00 to +10.00
  const MAX_CYL = 6.00;  // example: -6.00 to +6.00

  const tooHigh = (v, max) => v != null && Math.abs(v) > max;

  return (
    tooHigh(sphR, MAX_SPH) ||
    tooHigh(sphL, MAX_SPH) ||
    tooHigh(cylR, MAX_CYL) ||
    tooHigh(cylL, MAX_CYL)
  );
};


const showOutOfRangeMessage = () => {
  // Lock ATC + show a simple, calm instruction
  setAtcLocked(
    true,
    `Your prescription looks outside our standard online range for this lens option.
Please get in touch and we’ll advise the best lens build for you: ${CONTACT_URL}`
  );

  // Optional: store a line item property so you see it in cart/admin (remove if you don’t want this)
  setLineItemProperty("Rx review needed", "Outside online range");
};

const clearOutOfRangeMessage = () => {
  removeLineItemProperty("Rx review needed");
};

const maybeApplyRxRecommendation = () => {
  if (window.__JOIUSS_APPLYING__) return;

  window.__JOIUSS_APPLYING__ = true;

  console.log("[JOIUSS RX] state snapshot", {
  mode: state.mode,
  intent: state.intent,
  use: state.use,
  type: state.type,
  sphR: state.rx?.r?.sph,
  sphL: state.rx?.l?.sph,
  cylR: state.rx?.r?.cyl,
  cylL: state.rx?.l?.cyl,
  axisR: state.rx?.r?.axis,
  axisL: state.rx?.l?.axis,
});


  try {
    const recIndex = recommendPackageSuffixFromState({});

    // Only show the contact message when prescription is TRULY out-of-range
    if (isRxOutOfRange()) {
      showOutOfRangeMessage();
      return;
    }

    // Entry-level fallback: if Rx isn't complete yet, still switch to the correct "starter" package
    const fallbackIndex =
      recIndex == null &&
      (state.intent === "prescription" || state.intent === "ready_readers") &&
      !rxLooksCompleteEnoughToJudgeRange()
        ? getDefaultRxPackageIndex()
        : null;

    const packageIndex = recIndex ?? fallbackIndex;

    // If neither real mapping nor fallback can decide, do nothing (no loops, no errors)
    if (packageIndex == null) {
      return;
    }


    // If we got here, we are in-range. Make sure any prior out-of-range flag is cleared.
    clearOutOfRangeMessage();

    const ok = switchToPackageIndex(packageIndex);

    // If switching fails (variant doesn’t exist), stop trying and show a contact message
    // instead of repeatedly hammering the DOM.
    if (!ok) {
      showOutOfRangeMessage();
      return;
    }

    // Store for debugging/cart clarity
    setLineItemProperty("Lens package index", String(packageIndex));

    if (recIndex == null && fallbackIndex != null) {
      setLineItemProperty("_Lens package default", "Entry package (pre-Rx)");
    } else {
      removeLineItemProperty("_Lens package default");
    }
  } finally {
    window.__JOIUSS_APPLYING__ = false;
  }
};


  // ============================================================
  // 8) EVENTS
  // ============================================================
    // ============================================================
// JOIUSS: Swatch click capture (prevents other scripts blocking swatch clicks)
// ============================================================

  // Close tooltips on outside click / Escape (only bind once)
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-joiuss-lens]")) return;
    if (e.target.closest("[data-tip]") || e.target.closest("[data-tooltip]")) return;
    closeAllTooltips();
  });

  // ============================================================
// RX UPLOAD: trigger real form file input + reflect filename
// ============================================================

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-rx-upload-choose]");
  if (!btn) return;

  // Make sure the real file input exists in the product form
  ensureRxUploadInput();

  const input = getFormRxUploadInput();
  if (!input) return;

  // Remove the "hidden" attribute if present — some browsers won't open the
  // file picker on a hidden element. The input is inside a display:none wrapper
  // so removing "hidden" has no visual effect.
  input.removeAttribute("hidden");

  input.click(); // opens native file picker
});

// ============================================================
// RX AUTO-FILL: parse uploaded prescription via Cloudflare Worker
// ============================================================

/**
 * Endpoint of the JOIUSS Rx Parser Cloudflare Worker.
 * Update this URL after deploying the Worker.
 */
const RX_PARSER_URL = "https://joiuss-rx-parser.paul-cb8.workers.dev/parse";

/**
 * Set a value on a data-rx input/select and fire the input event
 * so the existing state + ATC lock logic picks it up automatically.
 */
function setRxField(rxKey, eye, value) {
  const root = uiRoot();
  if (!root) return;

  let el;
  if (eye) {
    el = root.querySelector(`[data-step="rx"] [data-rx="${rxKey}"][data-eye="${eye}"]`);
  } else {
    el = root.querySelector(`[data-step="rx"] [data-rx="${rxKey}"]`);
  }

  if (!el) return;

  // Format numbers to 2dp for SPH/CYL/ADD, integer for Axis
  let formatted;
  if (rxKey === "axis") {
    formatted = value !== null && value !== undefined ? String(Math.round(Number(value))) : "";
  } else if (typeof value === "number") {
    formatted = value.toFixed(2);
  } else {
    formatted = value !== null && value !== undefined ? String(value) : "";
  }

  el.value = formatted;

  // Fire input event so the existing handler updates state + line item properties
  el.dispatchEvent(new Event("input", { bubbles: true }));
}

/**
 * Show or hide the auto-fill spinner and status message.
 * status: "loading" | "success" | "warning" | "error" | null
 */
function setRxParseStatus(status, message) {
  const root = uiRoot();
  if (!root) return;

  const spinnerEl = root.querySelector("[data-rx-parse-spinner]");
  const noticeEl  = root.querySelector("[data-rx-autofill-notice]");
  const textEl    = root.querySelector("[data-rx-autofill-notice-text]");

  if (spinnerEl) spinnerEl.hidden = status !== "loading";

  if (noticeEl) {
    noticeEl.hidden = !status || status === "loading";
    noticeEl.dataset.rxAutofillNotice = status || "";
  }

  if (textEl && message) textEl.textContent = message;
}

/**
 * Auto-fill the Rx fields from a parsed values object returned by the Worker.
 */
function autoFillRxFields(values) {
  const root = uiRoot();
  if (!root) return;

  // ── Determine the current prescription intent ─────────────────────────────
  // state.use: "single_gv" (distance), "single_nv" (reading), "varifocal", "bifocal"
  const currentUse = state.use || "";
  const isReading    = currentUse === "single_nv";
  const isMultifocal = currentUse === "varifocal" || currentUse === "bifocal";

  // ── PD ────────────────────────────────────────────────────────────────────
  if (values.pd_r !== null && values.pd_l !== null) {
    // Switch to mono PD mode first
    const monoBtn = root.querySelector('[data-step="rx"] [data-pd-mode="mono"]');
    if (monoBtn && !monoBtn.classList.contains("is-active")) monoBtn.click();
    setTimeout(() => {
      setRxField("pd_r", null, values.pd_r);
      setRxField("pd_l", null, values.pd_l);
    }, 50);
  } else if (values.pd !== null) {
    setRxField("pd", null, values.pd);
  }

  // ── ADD resolution ────────────────────────────────────────────────────────
  // Resolve per-eye ADD values (most prescriptions have a single shared ADD)
  const addR = values.add_r ?? values.add ?? null;
  const addL = values.add_l ?? values.add ?? null;

  // ── SPH (with reading ADD correction) ────────────────────────────────────
  // For reading glasses: the optician writes a distance Rx + ADD.
  // The reading SPH = distance SPH + ADD.  We populate SPH with the combined
  // value so the lens wizard sees the correct reading power.
  if (isReading) {
    const sphR = values.sph_r !== null ? values.sph_r : null;
    const sphL = values.sph_l !== null ? values.sph_l : null;
    if (sphR !== null && addR !== null) {
      setRxField("sph", "r", parseFloat((sphR + addR).toFixed(2)));
    } else if (sphR !== null) {
      setRxField("sph", "r", sphR);
    }
    if (sphL !== null && addL !== null) {
      setRxField("sph", "l", parseFloat((sphL + addL).toFixed(2)));
    } else if (sphL !== null) {
      setRxField("sph", "l", sphL);
    }
  } else {
    if (values.sph_r !== null) setRxField("sph", "r", values.sph_r);
    if (values.sph_l !== null) setRxField("sph", "l", values.sph_l);
  }

  // ── CYL & Axis ────────────────────────────────────────────────────────────
  // Helper: activate the no_cyl toggle for one eye inline.
  // The no_cyl handler lives inside the "click" listener (not "change"),
  // so we cannot rely on a dispatched event — we mirror the click handler directly.
  const activateNoCyl = (eye) => {
    const cb = root.querySelector(`[data-step="rx"] [data-rx-toggle="no_cyl"][data-eye="${eye}"]`);
    if (!cb) return;
    cb.checked = true;
    // Mirror what the click handler does
    state.rx.no_cyl[eye] = true;
    state.rx[eye].cyl  = null;
    state.rx[eye].axis = null;
    const eyeBlock = root.querySelector(`[data-rx-cylaxis][data-eye="${eye}"]`);
    if (eyeBlock) eyeBlock.classList.add("is-disabled");
    const side = eye.toUpperCase();
    setLineItemProperty(`Rx CYL (${side})`, "None");
    setLineItemProperty(`Rx Axis (${side})`, "None");
  };

  if (values.no_cyl_r) {
    activateNoCyl("r");
  } else {
    if (values.cyl_r !== null)  setRxField("cyl",  "r", values.cyl_r);
    if (values.axis_r !== null) setRxField("axis", "r", values.axis_r);
  }

  if (values.no_cyl_l) {
    activateNoCyl("l");
  } else {
    if (values.cyl_l !== null)  setRxField("cyl",  "l", values.cyl_l);
    if (values.axis_l !== null) setRxField("axis", "l", values.axis_l);
  }

  // ── ADD / near_sph (varifocal / bifocal only) ─────────────────────────────
  // For varifocal/bifocal: populate the near_sph field (= distance SPH + ADD).
  // The existing input handler computes state.rx.add from near_sph - sph, so
  // firing an "input" event on near_sph is sufficient to set state.rx.add.
  // For reading: ADD has already been folded into SPH above — do NOT populate near_sph.
  if (isMultifocal) {
    const sphR = values.sph_r !== null ? values.sph_r : 0;
    const sphL = values.sph_l !== null ? values.sph_l : 0;
    if (addR !== null) setRxField("near_sph", "r", parseFloat((sphR + addR).toFixed(2)));
    if (addL !== null) setRxField("near_sph", "l", parseFloat((sphL + addL).toFixed(2)));
  }

  // ── Prism ─────────────────────────────────────────────────────────────────
  // Check if any prism value is present in the parsed prescription
  const hasPrism = (
    values.prism_h_r !== null || values.prism_v_r !== null ||
    values.prism_h_l !== null || values.prism_v_l !== null
  );

  if (hasPrism) {
    // 1. Tick the prism checkbox and directly reveal the prism field wrappers.
    //    The prism toggle handler lives inside the "click" listener (not "change"),
    //    so we cannot rely on a dispatched event — we do the work inline instead.
    const prismCb = root.querySelector('[data-step="rx"] [data-rx-toggle="prism"]');
    if (prismCb && !prismCb.checked) {
      prismCb.checked = true;
      // Update state directly (mirrors what the click handler does)
      state.rx.prism_enabled = true;
      // Reveal all prism field wrappers
      root.querySelectorAll('[data-prism-wrap]').forEach((el) => { el.hidden = false; });
    }

    // 2. Populate prism magnitude inputs (fire "input" so the existing handler
    //    updates state.rx[eye].prism_h / prism_v and writes line item props)
    if (values.prism_h_r !== null) {
      setRxField("prism_h", "r", values.prism_h_r);
      state.rx.r.prism_h = values.prism_h_r;
    }
    if (values.prism_v_r !== null) {
      setRxField("prism_v", "r", values.prism_v_r);
      state.rx.r.prism_v = values.prism_v_r;
    }
    if (values.prism_h_l !== null) {
      setRxField("prism_h", "l", values.prism_h_l);
      state.rx.l.prism_h = values.prism_h_l;
    }
    if (values.prism_v_l !== null) {
      setRxField("prism_v", "l", values.prism_v_l);
      state.rx.l.prism_v = values.prism_v_l;
    }

    // 3. Set base direction selects and update state directly
    //    (selects fire "input" events but the input handler doesn't cover them,
    //    so we also update state directly and call writePrismProps)
    const setBase = (rxKey, eye, value) => {
      if (!value) return;
      const el = root.querySelector(`[data-step="rx"] [data-rx="${rxKey}"][data-eye="${eye}"]`);
      if (el) {
        el.value = value;
        el.dispatchEvent(new Event("change", { bubbles: true }));
      }
      state.rx[eye][rxKey] = value;
    };

    setBase("base_h", "r", values.base_h_r);
    setBase("base_v", "r", values.base_v_r);
    setBase("base_h", "l", values.base_h_l);
    setBase("base_v", "l", values.base_v_l);

    // 4. Write the line item properties for prism (both eyes)
    writePrismProps("r");
    writePrismProps("l");
  }

  // Trigger a full render + recommendation pass after all fields are set
  setTimeout(() => {
    maybeApplyRxRecommendation();
    syncAtcLockToState();
    updateSummaryFromState();
  }, 100);
}

/**
 * Convert an image File to a JPEG Blob using a browser Canvas.
 * Returns the original file if it's already a supported format or a PDF.
 */
async function normaliseImageFile(file) {
  const OPENAI_SUPPORTED = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif", "application/pdf"];
  if (OPENAI_SUPPORTED.includes(file.type.toLowerCase())) return file;

  // Attempt canvas conversion for unsupported image types (AVIF, HEIC, BMP, TIFF, etc.)
  try {
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement("canvas");
    canvas.width  = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close();
    return await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(new File([blob], file.name.replace(/\.[^.]+$/, ".jpg"), { type: "image/jpeg" }));
        else reject(new Error("Canvas conversion failed"));
      }, "image/jpeg", 0.92);
    });
  } catch {
    // If conversion fails, return original and let the Worker handle the error
    return file;
  }
}

/**
 * Send the uploaded file to the Rx Parser Worker and auto-fill the fields.
 * Called immediately after a file is chosen.
 */

  // Scroll directly to the PD "Last step" card after the parser reveals the Rx fields.
  // Uses requestAnimationFrame so the DOM has been painted before we measure.
  const scrollToPdRow = () => {
    requestAnimationFrame(() => {
      const pdRow = uiRoot()?.querySelector("[data-pd-row]");
      if (!pdRow) return;
      const offset = getStickyOffset();
      const rect   = pdRow.getBoundingClientRect();
      const top    = Math.max(0, window.scrollY + rect.top - offset - 12);
      window.scrollTo({ top, behavior: prefersReducedMotion() ? "auto" : "smooth" });
    });
  };

async function tryAutoFillRx(file) {
  setRxParseStatus("loading");

  // Abort the fetch if it takes longer than 20 seconds
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), 20_000);

  try {
    // Convert unsupported formats (AVIF, HEIC, etc.) to JPEG before sending
    const normalisedFile = await normaliseImageFile(file);

    const form = new FormData();
    form.append("prescription", normalisedFile);

    const res = await fetch(RX_PARSER_URL, {
      method: "POST",
      body:   form,
      signal: controller.signal,
    });

    window.clearTimeout(timeoutId);

    if (!res.ok) {
      throw new Error(`Worker returned ${res.status}`);
    }

    const data = await res.json();

    if (!data.success || !data.values) {
      throw new Error(data.error || "No values returned");
    }

    // Auto-fill the fields
    autoFillRxFields(data.values);

    // Show appropriate notice based on confidence
    if (data.confidence === "high") {
      setRxParseStatus(
        "success",
        "We've read your prescription and filled in the values below. Please check them before continuing."
      );
    } else {
      const warningText = data.warnings?.length
        ? `We've filled in what we could read \u2014 please check the values carefully. Note: ${data.warnings.join("; ")}.`
        : "We've filled in what we could read \u2014 please check and correct the values below before continuing.";
      setRxParseStatus("warning", warningText);
    }

    // Reveal the Rx fields now that parsing is complete
    state.rx.rx_parsed = true;
    render();
    scrollToPdRow(); // jump straight to the PD card

  } catch (err) {
    window.clearTimeout(timeoutId);
    console.warn("JOIUSS: Rx auto-fill failed", err);

    // Distinguish a timeout/abort from a genuine server error
    const isTimeout = err?.name === "AbortError";
    const errMsg = isTimeout
      ? "Reading your prescription is taking longer than expected. Please enter your values manually below, or try uploading again."
      : "We couldn't read your prescription automatically. Please enter your values manually below.";

    setRxParseStatus("error", errMsg);
    // Still reveal the Rx fields so the customer can enter values manually
    state.rx.rx_parsed = true;
    render();
    scrollToPdRow(); // jump straight to the PD card even on error
  }
}

document.addEventListener("change", (e) => {
    const input = e.target.closest(
      '[data-joiuss-rx-upload] input[type="file"]'
    );
      if (!input) return;

    const file = input.files?.[0] || null;

    // state
    state.rx.uploaded = !!file;

      if (file) {
        // If they upload a file, they are NOT "sending later"
        state.rx.send_later = false;
        const cb = uiRoot()?.querySelector('[data-rx-toggle="send_later"]');
        if (cb) cb.checked = false;

        setLineItemProperty("Prescription upload", "YES");
        setLineItemProperty("Prescription filename", file.name);

        // 🔬 Trigger Rx auto-fill from uploaded file
        tryAutoFillRx(file);

      } else {
        setLineItemProperty("Prescription upload", "NO");
        removeLineItemProperty("Prescription filename");
        // Clear any auto-fill notice if file is removed
        setRxParseStatus(null);
        // Hide the Rx fields again until a new file is uploaded and parsed
        state.rx.rx_parsed = false;
      }



      // Show filename in RX UI
      const nameEl = uiRoot()?.querySelector("[data-rx-upload-filename]");
      if (nameEl) {
        if (file) {
          nameEl.textContent = `Selected: ${file.name}`;
          nameEl.hidden = false;
        } else {
          nameEl.textContent = "";
          nameEl.hidden = true;
        }
      }

          // Update pill style + label in RX UI
        const wrapEl = uiRoot()?.querySelector("[data-rx-upload-wrap]");
        const btnEl = uiRoot()?.querySelector("[data-rx-upload-choose]");

        if (wrapEl && btnEl) {
          if (file) {
            wrapEl.classList.add("is-uploaded");
            btnEl.textContent = "Prescription uploaded";
            btnEl.setAttribute("aria-pressed", "true");
          } else {
            wrapEl.classList.remove("is-uploaded");
            btnEl.textContent = "Choose file";
            btnEl.setAttribute("aria-pressed", "false");
          }
        }
        syncAtcLockToState();

        });

  document.addEventListener("change", (e) => {
  const cb = e.target.closest?.('[data-rx-toggle="send_later"]');
  if (!cb) return;

    // ✅ state tracking
  state.rx.send_later = !!cb.checked;

  // When ticking send_later, remember whether a prescription was already uploaded
  // so we can restore the form if they untick it
  if (cb.checked) {
    state.rx._upload_snapshot = {
      uploaded: state.rx.uploaded,
      rx_parsed: state.rx.rx_parsed,
      filename: uiRoot()?.querySelector('[data-rx-upload-filename]')?.textContent || "",
    };
    state.rx.uploaded = false;
    state.rx.rx_parsed = false;
  } else {
    // Restore previous upload state if there was one
    const snap = state.rx._upload_snapshot;
    if (snap?.rx_parsed) {
      state.rx.uploaded = snap.uploaded;
      state.rx.rx_parsed = snap.rx_parsed;
    }
    // Keep snapshot in state until UI restoration below, then clear it
  }


  const btnEl = uiRoot()?.querySelector("[data-rx-upload-choose]");
  const wrapEl = uiRoot()?.querySelector("[data-rx-upload-wrap]");
  const nameEl = uiRoot()?.querySelector("[data-rx-upload-filename]");

  if (!btnEl || !wrapEl) return;

  if (cb.checked) {
    // Visually disable UI
    btnEl.disabled = true;
    // keep UI disable/fade consistent everywhere
    applySendLaterUI();


    // Clear display state
    wrapEl.classList.remove("is-uploaded");
    if (nameEl) {
      nameEl.textContent = "";
      nameEl.hidden = true;
    }

    // Also clear the real form input so no file is accidentally carried
    const real = getFormRxUploadInput?.();
    if (real) real.value = "";
      setLineItemProperty("Prescription upload", "NO");
      removeLineItemProperty("Prescription filename");

  } else {
    btnEl.disabled = false;
    // Restore upload card appearance if there was a previous upload
    const snap = state.rx._upload_snapshot || {};
    if (snap.rx_parsed && snap.uploaded) {
      wrapEl?.classList.add("is-uploaded");
      const nameEl2 = uiRoot()?.querySelector("[data-rx-upload-filename]");
      if (nameEl2 && snap.filename) {
        nameEl2.textContent = snap.filename;
        nameEl2.hidden = false;
      }
      const btnEl2 = uiRoot()?.querySelector("[data-rx-upload-choose]");
      if (btnEl2) btnEl2.textContent = "Prescription uploaded";
    }
    state.rx._upload_snapshot = null;
  }

    // ✅ lock/unlock ATC immediately
  syncAtcLockToState();

  });


  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAllTooltips();
  });

  document.addEventListener("click", (e) => {
      // STEP 2: Active root scoping (critical for Preview/Editor)
    const rootFromClick = e.target.closest("[data-joiuss-lens]");
    if (rootFromClick) ACTIVE_ROOT = rootFromClick;

    // Tooltip buttons
    const tipBtn = e.target.closest("[data-tip]");
    if (tipBtn) {
      e.preventDefault();
      toggleTooltip(tipBtn.getAttribute("data-tip"));
      return;
    }

    // Mode buttons
    const modeBtn = e.target.closest("button[data-mode]");
    if (modeBtn) {
      e.preventDefault();

      const nextMode = modeBtn.getAttribute("data-mode");
      const prevMode = state.mode;

      // If they switched lens paths, fully reset
      if (nextMode && nextMode !== prevMode) {
        resetAllLensSelectorState();
      }

      state.mode = nextMode;

      if (state.mode !== "custom") {
        state.intent = null;
        resetDownstreamAfterIntent();
      }

      if (state.mode === "frame") {
        setSummaryText("Frame only");
        switchToVariantIndex0();
        setLineItemProperty("Lens type", "Demo - JOIUSS logo on left lens - not for everyday wear");
        removeLineItemProperty("_Lens key");
      } else {
        setSummaryText("Custom lenses (choose options)");
        setLineItemProperty("Lens selection", "Custom lenses (choose options)");
      }

      render();
      return;
    }

    // Intent buttons
    // Intent buttons (allow them anywhere inside the active lens UI)
    const intentBtn = e.target.closest('button[data-intent]');
    if (intentBtn && intentBtn.closest('[data-joiuss-lens]')) {
      e.preventDefault();

  if (state.mode !== "custom") state.mode = "custom";

    const nextIntent = intentBtn.getAttribute("data-intent");
    if (state.intent !== nextIntent) {
      resetAllLensSelectorState();
      state.intent = nextIntent;
    }


  // Ready Readers: behaves like single vision + forced PD 62
  if (state.intent === "ready_readers") {
    state.use = "single_nv";
    setLineItemProperty("Lens use", "single_nv");

    // Ready Readers never uses bifocal shape
    state.bifocal_shape = null;
    removeLineItemProperty("Bifocal shape");

    // Forced PD for Ready Readers
    setLineItemProperty("PD", "62");

    // Default the RR power so package switching works immediately
    if (state.reader_power == null) {
      state.reader_power = 0.25;
          setLineItemProperty("Reader power", formatPower025(state.reader_power));
    if (readerReadout()) readerReadout().textContent = formatPower025(state.reader_power);

    }

  }

  const label =
    state.intent === "clear"
      ? "Custom lenses · Clear fashion (no prescription)"
      : state.intent === "ready_readers"
      ? "Custom lenses · Ready Readers"
      : "Custom lenses · Prescription";

  setSummaryText(label);
  setLineItemProperty("Lens selection", label);

  render();
  return;
}


    // Use buttons (Prescription type)
    const useBtn = e.target.closest('button[data-use]');
    if (useBtn && useBtn.closest('[data-step="use"]')) {
      e.preventDefault();

      const nextUse = useBtn.getAttribute("data-use");
      const changed = state.use !== nextUse;

      state.use = nextUse;
      setLineItemProperty("Lens use", state.use);

      // --- Downstream reset when prescription type changes ---
if (changed) {
  // Preserve no_cyl toggles across use-change so the customer doesn’t lose
  // their "No CYL" selection when switching e.g. single → varifocal.
  const savedNoCyl = { r: !!state.rx?.no_cyl?.r, l: !!state.rx?.no_cyl?.l };

  // Changing use invalidates bifocal shape unless we are staying in bifocal
  if (state.use !== "bifocal") {
    state.bifocal_shape = null;
    removeLineItemProperty("Bifocal shape");
  }

  // Leaving multifocal clears Near SPH + ADD
  if (state.use !== "varifocal" && state.use !== "bifocal") {
    state.rx.add = null;
    state.rx.r.near_sph = null;
    state.rx.l.near_sph = null;
    removeLineItemProperty("Rx ADD");
  }

  // Restore no_cyl so the customer's "No CYL" choice survives the use-change
  state.rx.no_cyl = savedNoCyl;
}


      // If leaving bifocal, clear shape + property
      if (changed && state.use !== "bifocal") {
        state.bifocal_shape = null;
        removeLineItemProperty("Bifocal shape");
        bifocalWrap()
          ?.querySelectorAll("[data-bifocal-shape-btn]")
          ?.forEach((b) => b.classList.remove("is-active"));
      }

      closeAllTooltips();
      render();

      // If they already picked a lens option (clear/blue/sun/trans/etc),
      // immediately switch to the equivalent entry package for the new Use.
      maybeApplyRxRecommendation();

      return;

    }

    // Bifocal shape buttons (only relevant when bifocal selected)
    const shapeBtn = e.target.closest("[data-bifocal-shape-btn]");
    if (
    shapeBtn &&
    shapeBtn.getAttribute("data-value") === "R 24mm" &&
    bifocalRequiresD28()
    ) {
    return; // blocked by lens type
    }


    if (shapeBtn && shapeBtn.closest("[data-bifocal-shape-wrap]")) {
      e.preventDefault();

      if (!needsBifocalShape()) return;

      const v = (shapeBtn.getAttribute("data-value") || "").trim();
      if (!v) return;

      state.bifocal_shape = v;
      setLineItemProperty("Bifocal shape", v);

      closeAllTooltips();
      render();

      // ✅ Now that seg shape exists, we can select the entry package for bifocals immediately
      maybeApplyRxRecommendation();
      return;

    }

    // Type buttons (Lens option)
    const typeBtn = e.target.closest('button[data-type]');
    if (typeBtn && typeBtn.closest('[data-step="type"]')) {
      e.preventDefault();

      const nextType = normalizeLensType(typeBtn.getAttribute("data-type"));

      // If lens option changes, reset colour
      if (state.type !== nextType) {
        state.type = nextType;
        state.colour = null;
        removeLineItemProperty("Lens colour");

        // Ready Readers must have a power to select the correct package
      if (state.intent === "ready_readers" && state.reader_power == null) {
        state.reader_power = 0.25;
        setLineItemProperty("Reader power", formatPower025(state.reader_power));
        if (readerReadout()) readerReadout().textContent = formatPower025(state.reader_power);
      }


        // NEW: for Clear fashion / Ready Readers, switch variant by lens type
        // ✅ Auto-default for Prescription:
// When they choose a lens type (clear/blue/polar/sun/trans) and RX is low-range,
// snap the "Use" to the first option immediately (Distance & General Vision).
if (state.intent === "prescription" && rxIsLowRangeForAutoDefault()) {
// If they haven't chosen a prescription type yet, default to Distance & General Vision
if (!state.use) {
  state.use = "single_gv";
  setLineItemProperty("Lens use", state.use);

  // Clear bifocal shape in case anything stale exists
  state.bifocal_shape = null;
  removeLineItemProperty("Bifocal shape");
}

}

        
      }

      setLineItemProperty("Lens type", state.type);

      closeAllTooltips();
      render();
      maybeApplyRxRecommendation();
      maybeApplyNonRxLensTypeVariant();
      return;
    }

    // Ready Readers: +/- nudge buttons
    const readerNudge = e.target.closest("[data-reader-nudge]");
    if (readerNudge) {
    e.preventDefault();

    if (state.intent !== "ready_readers") return;

    const dir = Number(readerNudge.getAttribute("data-reader-nudge") || "0");
    const current = state.reader_power != null ? state.reader_power : 0.25;

    setReaderPower(current + dir * 0.25);

    closeAllTooltips();
    render();
      return;
    }

    // RX: modal open/close
    const pdPhotoBtn = e.target.closest("[data-rx-photo]");
    if (pdPhotoBtn) {
      e.preventDefault();
      const id = pdPhotoBtn.getAttribute("data-rx-photo");
      const m = rxModal(id);
      if (m) m.hidden = false;
      return;
    }
    const modalClose = e.target.closest("[data-rx-modal-close]");
    if (modalClose) {
      const m = modalClose.closest("[data-rx-modal]");
      if (m) m.hidden = true;
      return;
    }

    // ============================================================
// RX: Mono PD toggle (separate Right/Left PDs)
// ============================================================
const monoPdToggle = e.target.closest('[data-step="rx"] [data-pd-mode="mono"]');
if (monoPdToggle) {
  const on = !!monoPdToggle.checked;

  // Store mode
  state.rx.pd_mode = on ? "mono" : "binocular";

  // Show/hide mono UI
  const wrap = stepRx()?.querySelector("[data-mono-pd-wrap]");
  if (wrap) wrap.hidden = !on;

  // Binocular PD input
  const pdInput = stepRx()?.querySelector('[data-rx="pd"]');
  if (pdInput) {
    pdInput.disabled = on;
    pdInput.classList.toggle("req", !on);
  }

  // Mono inputs required when ON
  const pdR = stepRx()?.querySelector('[data-rx="pd_r"]');
  const pdL = stepRx()?.querySelector('[data-rx="pd_l"]');

  if (pdR) pdR.classList.toggle("req", on);
  if (pdL) pdL.classList.toggle("req", on);

  if (on) {
    // Switching to mono: remove binocular PD property
    state.rx.pd = null;
    removeLineItemProperty("PD");
  } else {
    // Switching back to binocular: clear mono props
    state.rx.pd_r = null;
    state.rx.pd_l = null;
    removeLineItemProperty("Mono PD (R)");
    removeLineItemProperty("Mono PD (L)");
  }

  render();
  return;
}


    // RX: toggles
    const rxToggle = e.target.closest('[data-step="rx"] [data-rx-toggle]');
    if (rxToggle) {
      const t = rxToggle.getAttribute("data-rx-toggle");
      const on = !!rxToggle.checked;

    if (t === "no_cyl") {
      const eye = rxToggle.getAttribute("data-eye"); // "r" or "l"
      if (!eye) return;

      state.rx.no_cyl[eye] = on;

      // disable ONLY that eye's cyl/axis container
      const eyeBlock = stepRx()?.querySelector(`[data-rx-cylaxis][data-eye="${CSS.escape(eye)}"]`);
      if (eyeBlock) eyeBlock.classList.toggle("is-disabled", on);

      const side = eye.toUpperCase();

      if (on) {
        // Clear stored values (optional but tidy)
        state.rx[eye].cyl = null;
        state.rx[eye].axis = null;

        // Write "None" line items for THIS eye only
        setLineItemProperty(`Rx CYL (${side})`, "None");
        setLineItemProperty(`Rx Axis (${side})`, "None");
      } else {
        // If turning back on, remove the "None" props so real values can be written
        removeLineItemProperty(`Rx CYL (${side})`);
        removeLineItemProperty(`Rx Axis (${side})`);
      }
    }

      if (t === "prism") {
        // store toggle state (rename to prism_enabled to avoid clashing with prism values)
        state.rx.prism_enabled = on;

        // NEW: show/hide the wrapper you added in Step 2.1
        uiRoot()
        ?.querySelectorAll("[data-prism-wrap]")
        ?.forEach((el) => (el.hidden = !on));


        // When turning OFF: clear all prism props (new split naming)
        if (!on) {
          // Optional: also clear inputs so the UI resets when turned back on
          ["r", "l"].forEach((eye) => {
          const root = uiRoot();
          if (!root) return;

          // Horizontal prism input
          const h = root.querySelector(`[data-rx="prism_h"][data-eye="${eye}"]`);
          if (h) h.value = "";

          // Vertical prism input
          const v = root.querySelector(`[data-rx="prism_v"][data-eye="${eye}"]`);
          if (v) v.value = "";

          // Reset bases visually
          const bh = root.querySelector(`[data-rx="base_h"][data-eye="${eye}"]`);
          if (bh) bh.value = "IN";

          const bv = root.querySelector(`[data-rx="base_v"][data-eye="${eye}"]`);
          if (bv) bv.value = eye === "r" ? "UP" : "DOWN";

          // Reset state
          state.rx[eye].prism_h = null;
          state.rx[eye].prism_v = null;
          state.rx[eye].base_h = "IN";
          state.rx[eye].base_v = eye === "r" ? "UP" : "DOWN";
        });



          // Reset base defaults in the UI
          const rBH = uiRoot()?.querySelector('[data-rx="base_h"][data-eye="r"]');
          const lBH = uiRoot()?.querySelector('[data-rx="base_h"][data-eye="l"]');
          const rBV = uiRoot()?.querySelector('[data-rx="base_v"][data-eye="r"]');
          const lBV = uiRoot()?.querySelector('[data-rx="base_v"][data-eye="l"]');
          if (rBH) rBH.value = "IN";
          if (lBH) lBH.value = "IN";
          if (rBV) rBV.value = "UP";
          if (lBV) lBV.value = "DOWN";

          // Clear state values
          ["r","l"].forEach((eye) => {
            if (!state.rx?.[eye]) return;
            state.rx[eye].prism_h = null;
            state.rx[eye].prism_v = null;
            state.rx[eye].base_h = "IN";
            state.rx[eye].base_v = eye === "r" ? "UP" : "DOWN";
          });

          // Remove NEW line item properties
          ["R","L"].forEach((side) => {
            removeLineItemProperty(`Rx Prism Horizontal (${side})`);
            removeLineItemProperty(`Rx Base Horizontal (${side})`);
            removeLineItemProperty(`Rx Prism Vertical (${side})`);
            removeLineItemProperty(`Rx Base Vertical (${side})`);
          });
        }

        syncAtcLockToState?.();
        updateSummaryFromState?.();
        return;
      }

      // ── PD later ──────────────────────────────────────────────────────────
      if (t === "pd_later") {
        state.rx.pd_later = on;

        // Show/hide the PD input wrap
        const pdInputWrap = uiRoot()?.querySelector("[data-pd-input-wrap]");
        if (pdInputWrap) pdInputWrap.hidden = on;

        if (on) {
          // Clear any entered PD values and write the "to provide" line item
          state.rx.pd    = null;
          state.rx.pd_r  = null;
          state.rx.pd_l  = null;
          const pdInput = uiRoot()?.querySelector('[data-rx="pd"]');
          if (pdInput) pdInput.value = "";
          setLineItemProperty("PD", "Customer to provide separately");
          removeLineItemProperty("Mono PD (R)");
          removeLineItemProperty("Mono PD (L)");
        } else {
          // Restore the PD input and clear the placeholder property
          removeLineItemProperty("PD");
        }

        syncAtcLockToState();
        updateSummaryFromState();
        return;
      }

      syncAtcLockToState();
      updateSummaryFromState();
      return;
    }

// RX: nudges (respect input min/max/step)
const rxNudge = e.target.closest("[data-rx-nudge]");
if (rxNudge) {
  e.preventDefault();

  const field = rxNudge.getAttribute("data-rx-nudge"); // pd/sph/cyl/axis/near_sph/pd_r/pd_l
  const eye = rxNudge.getAttribute("data-eye"); // r/l (optional for pd)
  const dir = Number(rxNudge.getAttribute("data-dir") || "0");

  const isMonoPd = field === "pd_r" || field === "pd_l";

  const input =
    field === "pd"
      ? stepRx()?.querySelector('[data-rx="pd"]')
      : isMonoPd
      ? stepRx()?.querySelector(`[data-rx="${CSS.escape(field)}"]`)
      : stepRx()?.querySelector(
          `[data-rx="${CSS.escape(field)}"][data-eye="${CSS.escape(eye)}"]`
        );

  if (!input) return;

  const numAttr = (el, name) => {
    const v = parseFloat(el.getAttribute(name));
    return Number.isFinite(v) ? v : null;
  };

  const step = (() => {
    const s = numAttr(input, "step");
    // Fallbacks only if step not set
    if (Number.isFinite(s) && s > 0) return s;
    if (field === "axis") return 1;
    if (field === "pd" || isMonoPd) return 0.5;
    return 0.25;
  })();

  const min = numAttr(input, "min");
  const max = numAttr(input, "max");

  const decimalsFromStep = (s) => {
    const str = String(s);
    return str.includes(".") ? str.split(".")[1].length : 0;
  };

  const clamp = (n, lo, hi) => {
    if (Number.isFinite(lo)) n = Math.max(lo, n);
    if (Number.isFinite(hi)) n = Math.min(hi, n);
    return n;
  };

  const snap = (n, base, s) => {
    if (!Number.isFinite(s) || s <= 0) return n;
    const b = Number.isFinite(base) ? base : 0;
    return Math.round((n - b) / s) * s + b;
  };

  // Current value (use state defaults if empty)
  const raw = String(input.value || "").trim();

  let current;
  if (raw === "" || !Number.isFinite(parseFloat(raw))) {
    // sensible defaults if empty:
    if (field === "pd") current = Number.isFinite(state?.rx?.pd) ? state.rx.pd : 63;
    else if (field === "pd_r") current = Number.isFinite(state?.rx?.pd_r) ? state.rx.pd_r : 31.5;
    else if (field === "pd_l") current = Number.isFinite(state?.rx?.pd_l) ? state.rx.pd_l : 31.5;
    else current = 0;
  } else {
    current = parseFloat(raw);
  }

  let next = current + dir * step;

  // snap to step (use min as snapping base when present)
  next = snap(next, min, step);

  // clamp to min/max from the input itself
  next = clamp(next, min, max);

 // format output
if (field === "axis") {
  input.value = String(Math.round(next));
} else {
  const d = decimalsFromStep(step);
  input.value = d > 0 ? next.toFixed(d) : String(Math.round(next));
}

// 🔑 Force RX listeners + Dawn listeners
input.dispatchEvent(new Event("input", { bubbles: true }));
input.dispatchEvent(new Event("change", { bubbles: true }));
return;
}

    // ============================================================
    // Variant mapping buttons
    const lensBtn = e.target.closest('[data-joiuss-lens-ui] button[data-lens-key]');
    if (lensBtn) {
      e.preventDefault();

      const map = readMap();
      if (!map) return console.warn("JOIUSS lens map missing");

      const key = lensBtn.getAttribute("data-lens-key");
      const variantId = map[key];
      if (!variantId) return console.warn("JOIUSS missing key:", key, map);

      const container = lensBtn.closest("[data-joiuss-lens-ui]");
      if (container) {
        container.querySelectorAll("button[data-lens-key]").forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-pressed", "false");
        });
        lensBtn.classList.add("is-active");
        lensBtn.setAttribute("aria-pressed", "true");
      }

      const friendlyLabel = lensBtn.textContent.trim() || "Lens selection";
      setSummaryText(friendlyLabel);
      setLineItemProperty("Lens selection", friendlyLabel);
      setLineItemProperty("_Lens key", key);

      setVariantIdsInForms(variantId);
      updateUrl(variantId);
      nudgeDawn(variantId);
      return;
    }
  });

// RX buttons are <button> clicks (they don't fire "input"), so also listen for clicks
document.addEventListener("click", (e) => {
  const rxEl =
    e.target.closest('[data-step="rx"] [data-rx]') ||
    e.target.closest('[data-step="rx"] button[data-eye]');

  if (!rxEl) return;

  // Let existing click handlers update state first, then apply recommendation
  setTimeout(() => {
  // After +/- buttons update the UI, read current SPH values back into state
  const rxRoot = document.querySelector('[data-step="rx"]') || document;

  const readSph = (eye) => {
    // Try the most likely selectors first
    const candidates = [
      `[data-step="rx"] [data-rx="sph"][data-eye="${eye}"]`,
      `[data-step="rx"] [data-eye="${eye}"][data-rx="sph"]`,
      `[data-step="rx"] input[name*="sph"][name*="${eye}"]`,
      `[data-step="rx"] select[name*="sph"][name*="${eye}"]`,
      `[data-step="rx"] input[id*="sph"][id*="${eye}"]`,
      `[data-step="rx"] select[id*="sph"][id*="${eye}"]`,
    ];

    for (const sel of candidates) {
      const el = rxRoot.querySelector(sel);
      if (!el) continue;

      const v = (el.value ?? el.textContent ?? "").toString().trim();
      if (v !== "") return v;
    }

    return null;
  };

  // Sync both eyes (safe even if one is missing)
  const r = readSph("r");
  const l = readSph("l");

  if (r != null) state.rx.r.sph = r;
  if (l != null) state.rx.l.sph = l;

  maybeApplyRxRecommendation();
}, 0);
});

// ============================================================
// RX INLINE VALIDATION HELPERS
// ============================================================

/**
 * Show or clear a per-field inline error hint.
 * @param {string} eye   - "r" or "l"
 * @param {string} field - "sph" | "cyl" | "axis"
 * @param {string|null} msg - error message, or null to clear
 */
function setRxFieldError(eye, field, msg) {
  const root = uiRoot();
  if (!root) return;

  // Error hint element
  const errEl = root.querySelector(
    `[data-rx-error][data-eye="${CSS.escape(eye)}"][data-field="${CSS.escape(field)}"]`
  );
  // The input itself
  const inputEl = root.querySelector(
    `[data-step="rx"] [data-rx="${CSS.escape(field)}"][data-eye="${CSS.escape(eye)}"]`
  );

  if (errEl) {
    if (msg) {
      errEl.textContent = msg;
      errEl.hidden = false;
    } else {
      errEl.textContent = "";
      errEl.hidden = true;
    }
  }

  if (inputEl) {
    inputEl.classList.toggle("is-invalid", !!msg);
    if (msg) {
      inputEl.setAttribute("aria-invalid", "true");
    } else {
      inputEl.removeAttribute("aria-invalid");
    }
  }
}

/**
 * Validate a single Rx eye field value and return an error message or null.
 * Rules:
 *   SPH  : must be a multiple of 0.25 within [-20, +20]
 *   CYL  : must be a multiple of 0.25 within [-10, +10]
 *   Axis : must be an integer within [0, 180]
 */
function validateRxField(field, rawValue) {
  if (rawValue === "" || rawValue == null) return null; // empty = not yet entered, not an error

  const val = parseFloat(rawValue);
  if (!Number.isFinite(val)) return "Please enter a valid number.";

  if (field === "sph") {
    if (val < -20 || val > 20) return "SPH must be between \u221220.00 and +20.00.";
    if (Math.round(val / 0.25) * 0.25 !== Math.round(val * 100) / 100)
      return "SPH must be in 0.25 steps (e.g. \u22121.25, +0.50).";
  }

  if (field === "cyl") {
    if (val < -10 || val > 10) return "CYL must be between \u221210.00 and +10.00.";
    if (Math.round(val / 0.25) * 0.25 !== Math.round(val * 100) / 100)
      return "CYL must be in 0.25 steps (e.g. \u22120.50, +0.25).";
  }

  if (field === "axis") {
    if (!Number.isInteger(val) || val < 0 || val > 180)
      return "Axis must be a whole number between 0 and 180.";
  }

  return null; // valid
}

// RX: inputs/selects inside the RX step
document.addEventListener("input", (e) => {
  const rxInput = e.target.closest?.('[data-step="rx"] [data-rx]');
  if (!rxInput) return;

  const k = rxInput.getAttribute("data-rx");
  const eye = rxInput.getAttribute("data-eye");

  // ============================================================
  // PD inputs (binocular + mono)
  // ============================================================

  // Mono PDs
  if (k === "pd_r" || k === "pd_l") {
    if (state.rx.pd_mode !== "mono") return;

    const raw = rxInput.value;

    if (raw === "") {
      if (k === "pd_r") {
        state.rx.pd_r = null;
        removeLineItemProperty("Mono PD (R)");
      } else {
        state.rx.pd_l = null;
        removeLineItemProperty("Mono PD (L)");
      }
      render();
      return;
    }

    const val = parseFloat(raw);
    if (!Number.isFinite(val)) return;

    if (k === "pd_r") {
      state.rx.pd_r = val;
      setLineItemProperty("Mono PD (R)", val);
    } else {
      state.rx.pd_l = val;
      setLineItemProperty("Mono PD (L)", val);
    }

    // Ensure binocular PD is not set
    state.rx.pd = null;
    removeLineItemProperty("PD");

    render();
    return;
  }

  // Binocular PD
  if (k === "pd") {
    if (state.rx.pd_mode === "mono") return; // ignore if mono is on

    const raw = rxInput.value;

    if (raw === "") {
      state.rx.pd = null;
      removeLineItemProperty("PD");
      render();
      return;
    }

    const val = parseFloat(raw);
    if (!Number.isFinite(val)) return;

    state.rx.pd = val;
    setLineItemProperty("PD", val);

    render();
    return;
  }

  // Eye fields
  if (eye && (k === "sph" || k === "cyl" || k === "axis" || k === "near_sph")) {
    state.rx[eye][k] = rxInput.value;

    // ── Inline validation for SPH / CYL / Axis ──
    if (k === "sph" || k === "cyl" || k === "axis") {
      const errMsg = validateRxField(k, rxInput.value);
      setRxFieldError(eye, k, errMsg);
    }

    const side = eye.toUpperCase();

    if (k === "sph") setLineItemProperty(`Rx SPH (${side})`, rxInput.value || "");
    if (k === "cyl" && !state.rx.no_cyl[eye]) setLineItemProperty(`Rx CYL (${side})`, rxInput.value || "");
    if (k === "axis" && !state.rx.no_cyl[eye]) setLineItemProperty(`Rx Axis (${side})`, rxInput.value || "");

    // Multifocal: compute ADD from Near SPH (Right only) - Distance SPH (Right)
    if (k === "near_sph" && eye === "r") {
      const dist = Number(state.rx.r.sph || 0);
      const near = Number(state.rx.r.near_sph || 0);
      const add = (near - dist);

      if (Number.isFinite(add) && Math.abs(add) > 0) {
        const fixed = Number(add.toFixed(2));
        state.rx.add = fixed;
        setLineItemProperty("Rx ADD", fixed.toFixed(2));
      } else {
        state.rx.add = null;
        removeLineItemProperty("Rx ADD");
      }
    }
  }

  maybeApplyRxRecommendation();
  syncAtcLockToState();
  updateSummaryFromState();
});


(function () {
  // 1) Get variants from Liquid injection
  const variants = Array.isArray(window.__JOIUSS_VARIANTS__) ? window.__JOIUSS_VARIANTS__ : [];

  // 2) Normalise text so mapping keys are stable
  const norm = (s) =>
    String(s ?? "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");

  // 3) Build an automatic map: "option1|option2|option3" -> variantId
  //    This is better than manual maps while you're proving the mechanism.
  const AUTO_MAP = {};
  for (const v of variants) {
    const key = [v.option1, v.option2, v.option3].map(norm).join("|");
    AUTO_MAP[key] = v.id;
  }

  // 4) Resolve variant id from a key you provide
  function resolveVariantIdFromKey(key) {
    return AUTO_MAP[norm(key)];
  }

  // 5) Select the variant by ID in a theme-agnostic way
  function selectVariantById(variantId) {
    if (!variantId) return false;

    // Common Shopify patterns:
    // A) <select name="id">
    const idSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (idSelect) {
      const opt = Array.from(idSelect.options).find((o) => String(o.value) === String(variantId));
      if (!opt) return false;
      idSelect.value = String(variantId);
      idSelect.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    // B) <input type="radio" name="id" value="...">
    const idRadio = document.querySelector(`form[action*="/cart/add"] input[name="id"][value="${variantId}"]`);
    if (idRadio) {
      idRadio.checked = true;
      idRadio.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    // C) Hidden <input name="id"> updated by scripts
    const idHidden = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idHidden) {
      idHidden.value = String(variantId);
      idHidden.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    }

    return false;
  }

  // 6) Public debug helpers (so you can prove it in console immediately)
  window.__JOIUSS_VARIANT_PROOF__ = {
    variants,
    AUTO_MAP,
    resolveVariantIdFromKey,
    selectVariantById,

    // Convenience: pass option values directly
    selectByOptions(option1, option2, option3) {
      const key = [option1, option2, option3].map(norm).join("|");
      const id = AUTO_MAP[key];
      return { key, id, ok: selectVariantById(id) };
    },

    // Convenience: pass a prebuilt key string "o1|o2|o3"
    selectByKey(key) {
      const id = resolveVariantIdFromKey(key);
      return { key: norm(key), id, ok: selectVariantById(id) };
    },
  };

  console.log("[JOIUSS proof] Ready. Try __JOIUSS_VARIANT_PROOF__.selectByOptions(...)");
})();


// ============================================================
// Clamp PD / Mono PD on blur (capture phase so it always fires)
// ============================================================
document.addEventListener(
  "blur",
  (e) => {
    const rxInput = e.target.closest?.('[data-step="rx"] [data-rx]');
    if (!rxInput) return;

    const k = rxInput.getAttribute("data-rx");

    // Binocular PD clamp 49–79
    if (k === "pd") {
      const v = parseFloat(rxInput.value);
      if (!Number.isFinite(v)) return;

      let val = Math.round(v * 2) / 2;
      val = Math.max(49, Math.min(79, val));
      rxInput.value = String(val);

      state.rx.pd = val;
      setLineItemProperty("PD", val);
      render();
      return;
    }

    // Mono PD clamp 24.5–39.5
    if (k === "pd_r" || k === "pd_l") {
      if (state.rx.pd_mode !== "mono") return;

      const v = parseFloat(rxInput.value);
      if (!Number.isFinite(v)) return;

      let val = Math.round(v * 2) / 2;
      val = Math.max(24.5, Math.min(39.5, val));
      rxInput.value = String(val);

      if (k === "pd_r") {
        state.rx.pd_r = val;
        setLineItemProperty("Mono PD (R)", val);
      } else {
        state.rx.pd_l = val;
        setLineItemProperty("Mono PD (L)", val);
      }

      // ensure binocular PD is not set
      state.rx.pd = null;
      removeLineItemProperty("PD");

      render();
    }
  },
  true
);

  // ============================================================
  // ORDER-PROOF PROPERTY SYNC
  // Rewrites all selected lens details directly into the real
  // submitted Shopify form immediately before add-to-cart.
  // Runs on both capture-phase submit and capture-phase click so
  // it fires before Dawn's own handlers, regardless of whether
  // the theme re-rendered the form between step selection and ATC.
  // ============================================================

  const upsertLineItemPropertyOnForm = (form, name, value) => {
    if (!form || !name) return;
    const propName = `properties[${name}]`;
    form
      .querySelectorAll(`input[name="${CSS.escape(propName)}"]`)
      .forEach((el) => el.remove());
    if (value == null || String(value).trim() === "") return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = propName;
    input.value = String(value);
    input.setAttribute("data-joiuss-final-property", "true");
    form.appendChild(input);
  };

  const syncJoiussPropertiesToForm = (form) => {
    if (!form) return;

    // Remove any previously injected final-property inputs
    form
      .querySelectorAll("[data-joiuss-final-property]")
      .forEach((el) => el.remove());

    upsertLineItemPropertyOnForm(form, "Lens selection", LAST_SUMMARY || "Frame only");

    if (state.mode === "frame") {
      upsertLineItemPropertyOnForm(
        form,
        "Lens type",
        "Demo - JOIUSS logo on left lens - not for everyday wear"
      );
      return;
    }

    upsertLineItemPropertyOnForm(form, "Lens use", state.use);
    upsertLineItemPropertyOnForm(form, "Lens type", state.type);
    upsertLineItemPropertyOnForm(form, "Lens colour", state.colour);
    upsertLineItemPropertyOnForm(form, "Bifocal shape", state.bifocal_shape);
    upsertLineItemPropertyOnForm(
      form,
      "Reader power",
      state.reader_power != null ? formatPower025(state.reader_power) : null
    );

    const packageIndex = recommendPackageSuffixFromState?.();
    if (packageIndex != null) {
      upsertLineItemPropertyOnForm(form, "Lens package index", packageIndex);
    }

    if (state.intent === "prescription") {
      if (state.rx.send_later) {
        upsertLineItemPropertyOnForm(form, "Prescription upload", "Send later");
      } else if (state.rx.uploaded) {
        upsertLineItemPropertyOnForm(form, "Prescription upload", "YES");
        // Preserve the actual file reference from the upload input
        const fileInput = getFormRxUploadInput?.();
        const file = fileInput?.files?.[0];
        if (file?.name) {
          upsertLineItemPropertyOnForm(form, "Prescription filename", file.name);
        }
      }
    }

    if (state.intent === "ready_readers") {
      upsertLineItemPropertyOnForm(form, "PD", "62");
    } else if (state.rx?.pd_later) {
      upsertLineItemPropertyOnForm(form, "PD", "Customer to provide separately");
    } else if (state.rx?.pd_mode === "mono") {
      upsertLineItemPropertyOnForm(form, "Mono PD (R)", state.rx.pd_r);
      upsertLineItemPropertyOnForm(form, "Mono PD (L)", state.rx.pd_l);
    } else {
      upsertLineItemPropertyOnForm(form, "PD", state.rx?.pd);
    }

    ["r", "l"].forEach((eye) => {
      const side = eye.toUpperCase();
      upsertLineItemPropertyOnForm(form, `Rx SPH (${side})`, state.rx?.[eye]?.sph);
      if (state.rx?.no_cyl?.[eye]) {
        upsertLineItemPropertyOnForm(form, `Rx CYL (${side})`, "None");
        upsertLineItemPropertyOnForm(form, `Rx Axis (${side})`, "None");
      } else {
        upsertLineItemPropertyOnForm(form, `Rx CYL (${side})`, state.rx?.[eye]?.cyl);
        upsertLineItemPropertyOnForm(form, `Rx Axis (${side})`, state.rx?.[eye]?.axis);
      }
      upsertLineItemPropertyOnForm(
        form,
        `Rx Prism Horizontal (${side})`,
        state.rx?.[eye]?.prism_h
      );
      upsertLineItemPropertyOnForm(
        form,
        `Rx Base Horizontal (${side})`,
        state.rx?.[eye]?.prism_h ? state.rx?.[eye]?.base_h : null
      );
      upsertLineItemPropertyOnForm(
        form,
        `Rx Prism Vertical (${side})`,
        state.rx?.[eye]?.prism_v
      );
      upsertLineItemPropertyOnForm(
        form,
        `Rx Base Vertical (${side})`,
        state.rx?.[eye]?.prism_v ? state.rx?.[eye]?.base_v : null
      );
    });

    upsertLineItemPropertyOnForm(form, "Rx ADD", state.rx?.add);
  };

    // Bind to capture-phase submit on the cart form
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target.closest?.('form[action*="/cart/add"]');
      if (!form) return;
      // Re-attach file input in case Dawn replaced the form since last render()
      ensureRxUploadInput();
      syncJoiussPropertiesToForm(form);
    },
    true
  );
  // Bind to capture-phase click on any ATC button
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest?.('button[name="add"], button[type="submit"]');
      if (!btn) return;
      const form = btn.closest?.('form[action*="/cart/add"]');
      if (!form) return;
      // Re-attach file input in case Dawn replaced the form since last render()
      ensureRxUploadInput();
      syncJoiussPropertiesToForm(form);
    },
    true
  );

  // Keep lock sticky in Theme Editor
  const startAtcLockObserver = () => {
    const target = document.querySelector("#MainContent") || document.body;
    if (!target) return;

    let t = null;
    const obs = new MutationObserver(() => {
      window.clearTimeout(t);
      t = window.setTimeout(() => render(), 60);
    });

    obs.observe(target, { childList: true, subtree: true });
  };

  document.addEventListener("shopify:section:load", () => render());
  document.addEventListener("shopify:section:select", () => render());
  document.addEventListener("shopify:section:reorder", () => render());
  document.addEventListener("shopify:block:select", () => render());

  updateSummaryFromState();
  updateLensColourTooltip();
  syncAtcLockToState();
  startAtcLockObserver();
  ensureRxUploadInput();

  // ============================================================
  // 9) INIT
  // ============================================================
  render();
})();
